/*global chrome*/
// import React, { Component } from "react";
import "antd/dist/antd.css";
import { connect } from "react-redux";
import cloneDeep from "lodash/cloneDeep";
import {
  Edit,
  AllInclusive,
  Storage,
  ReportProblem,
  AccountTree,
  Cancel,
  UnfoldLess,
  UnfoldMore,
  ExpandMore,
} from "@material-ui/icons";
import { Button, Modal, Switch, Tooltip } from "antd";
import { useParams } from "react-router-dom";
import React, { useState, useContext, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { v4 as uuid } from "uuid";
import { ADDABLE_SKILL_TYPES } from "../../../../../../../redux/constants/skillConstants";
import { notify } from "../../../../../../../redux/actions/snackActions";
import settingIcon from "../../../../../../../images/branching/setting-icon.svg";
import recordIcon from "../../../../../../../images/branching/record.svg";
import assertIcon from "../../../../../../../images/branching/assert.svg";
import waitIcon from "../../../../../../../images/branching/wait.svg";
import stopIcon from "../../../../../../../images/branching/stop.svg";
import branchIcon from "../../../../../../../images/branching/branching.svg";
import imageIcon from "../../../../../../../images/image-pic.png";
import playWhite from "../../../../../../../images/play-white.png";
import Loader from "../../../../../../../components/loader";
import readIcon from "../../../../../../../images/branching/readIcon.png";
import filesandfolders from "../../../../../../../images/branching/files.png";
import outlookIcon from "../../../../../../../images/branching/outlook-icon.png";
import outlookImage from "../../../../../../../images/branching/outlook-image.png";
import webAutomationIcon from "../../../../../../../images/template-img/web-automation.png";
import automationIcon from "../../../../../../../images/template-img/automation-icon.png";
import folderIcon from "../../../../../../../images/template-img/MIS.png";
import assign from "../../../../../../../images/assign.png";
import httpApi from "../../../../../../../images/httpApi.png";
import httpApiIcon from "../../../../../../../images/httpApiIcon.png";
import assignIcon from "../../../../../../../images/assignIcon.png";
import InvokeSkillIcon from "../../../../../../../images/InvokeSkillIcon.png";
import InvokeSkillImg from "../../../../../../../images/InvokeSkillImg.png";
import todoIcon from "../../../../../../../images/todo-icon.png";
import excelIcon from "../../../../../../../images/excel-action.png";
import automation from "../../../../../../../images/template-img/data-loading.png";
import echoIcon from "../../../../../../../images/branching/echoIcon.png";
import messageBoxIcon from "../../../../../../../images/branching/messageBoxIcon.png";
import reviewIcon from "../../../../../../../images/branching/review-icon.png";
import echoImage from "../../../../../../../images/branching/echo-image.png";
import messageBoxImage from "../../../../../../../images/branching/messageBox-image.png";
import kbdIcon from "../../../../../../../images/kbdIcon.png";
import kpIcon from "../../../../../../../images/kpIcon.png";
import javascriptImage from "../../../../../../../images/branching/javascriptImage.png";
import javascriptIcon from "../../../../../../../images/branching/javascriptIcon.png";
import imgEditIcon from "../../../../../../../images/edit-white.svg";
import breakIcon from "../../../../../../../images/break.png";
import continueIcon from "../../../../../../../images/continue.png";
import openAppIcon from "../../../../../../../images/branching/open-app.svg";
import openAppImage from "../../../../../../../images/branching/open-app-ill.svg";
import closeAppIcon from "../../../../../../../images/branching/close-app.svg";
import closeAppImage from "../../../../../../../images/branching/close-app-ill.svg";
import switchAppIcon from "../../../../../../../images/branching/switch-app.svg";
import switchAppImage from "../../../../../../../images/branching/switch-app-ill.svg";
import s3FileDownloadIcon from "../../../../../../../images/s3-file-download.png";
import s3ConnectIcon from "../../../../../../../images/s3-connect.png";
import s3Download from "../../../../../../../images/s3-file-download-illustration.png";
import s3Connect from "../../../../../../../images/AWS-S3-Connect.png";
import s3Archive from "../../../../../../../images/s3-archive-illustration.png";
import s3ArchiveIcon from "../../../../../../../images/s3-archive.png";
import readCred from "../../../../../../../images/read-illustration.png";
import readCredIcon from "../../../../../../../images/read-icon.svg";
import readTable from "../../../../../../../images/table-illustration.png";
import readTableIcon from "../../../../../../../images/table-icon.png";
import keyboardshortCutIcon from "../../../../../../../images/keyboard-shortcut.png";
import keyboardshortCut from "../../../../../../../images/keyboard-illustration.png";
import closeFileIcon from "../../../../../../../images/closefile-icon.png";
import closeFile from "../../../../../../../images/closefile-illustration.png";
import skillSetImage from "../../../../../../../images/SkillsetImage.png";
import skillSetIcon from "../../../../../../../images/SkillsetIcon.png";
import smtpIcon from "../../../../../../../images/smtp-icon.png";
import smtpImage from "../../../../../../../images/smtp-image.png";
import clipboardImg from "../../../../../../../images/clipboard-illustration.svg";
import clipboardIcon from "../../../../../../../images/clipboard-Icon.svg";
import dataExtactionIcon from "../../../../../../../images/data-extraction.svg";
import dataExtactionImg from "../../../../../../../images/data-extractionImg.svg";
import approvedIcon from "../../../../../../../images/Approved.png";
import rejectedIcon from "../../../../../../../images/Rejected.png";
import approveActionIcon from "../../../../../../../images/approval-action-img.png";
import xmlIcon from "../../../../../../../images/xml-icon.png";
import xmlIllustration from "../../../../../../../images/xml-illustration.png";
import dbIcon from "../../../../../../../images/db-icon.png";
import dbIllustration from "../../../../../../../images/db-illustration.png";
import hoverIcon from "../../../../../../../images/hover-icon.png";
import hoverIllustration from "../../../../../../../images/hover-illustration.png";

import settingIconFx from "../../../../../../../images/training/settings-icon.png";
import logsIconFx from "../../../../../../../images/training/logs-icon.png";
import startIconFx from "../../../../../../../images/training/started-icon.png";
import screenShotImg from "../../../../../../../images/training/Screenshot-Illustration.png";
import screenShotIcon from "../../../../../../../images/training/Screenshot-Img .png";
import gptIcon from "../../../../../../../images/ChatGPT_Icon.png";
import gptImage from "../../../../../../../images/ChatGPT_Illustration.png";
import ragIcon from "../../../../../../../images/ragIcon.png";
import ragImage from "../../../../../../../images/ragIllustration.png";
import ThrowAction_Icon from "../../../../../../../images/Throw Action_Icon.png";
import ThrowAction_Illustration from "../../../../../../../images/Throw Action_Illustration.png";
import arrowDownStart from "../../../../../../../images/arrow-down-start.svg";
import BrowserIcon from "../../../../../../../images/globe.svg";
import TemplateInstructions from "../../../../../../../components/templateInstructions";
import AppIcon from "../../../../../../../images/layers.svg";

import Zoom from "react-medium-image-zoom";
// import Blur from 'react-blur'

import "tui-image-editor/dist/tui-image-editor.css";
import ImageEditor from "@toast-ui/react-image-editor";

import _ from "lodash";
import $ from "jquery";

import { store } from "../../../../../../../redux";
import ConfigPanel from "./configPanel";
import AdvancedSettingsPanel from "./advancedSettingsPanel";
import LoopConfigPanel from "./loopConfigPanel";
import VariablesPanel from "./variablesPanel";
import ReadValueConfig from "./readValueConfig";
import FilesFoldersConfig from "./FilesFoldersConfig";
import ExcelConfig from "./ExcelConfig";
import MessageBoxConfig from "./messageBoxConfig";
import SendMailConfigForm from "./mailConfig";
import SMTPSendMailConfigForm from "./SMTPSendMailConfig";
import ConfigDataSet from "./configureDataSet";
import { Select, Drawer } from "antd";
import HttpApiConfig from "./httpApiConfigPanel";
import AssignConfig from "./assignConfig";
import InvokeSkillConfigForm from "./invokeSkillConfig";
import ToDoSkillConfigForm from "./toDoSkillConfig";
import FlowBuilder, {
  NodeContext,
  BuilderContext,
  buildFlatNodes,
  buildTreeNodes,
  useAction,
} from "react-flow-builder";
import { ReactNotifications, Store } from "react-notifications-component";

import {
  setDraft,
  startRecord,
  updateFormatedData,
  setAdvancedConfigPanel,
  updateDraftSkill,
  startTimer,
  closeAdvancedConfigPanel,
  setVariablePanel,
  setChatPanel,
  setRagPanel,
} from "../../../../../../../redux/actions/skill";
import { getCurrentUser } from "../../../../../../../redux/actions/organizationAction";
import {
  getFileUrl,
  updateFileUrl,
} from "../../../../../../../redux/actions/fileUpload";
import EchoConfig from "./echoConfig";
import TechnologyConfig from "./TechnologyConfig";
import OpenAppConfig from "./OpenAppConfig";
import CloseAppConfig from "./CloseAppConfig";
import SwitchAppConfig from "./SwitchAppConfig";
import ConfigS3 from "./ConfigS3";
import ConfigS3Download from "./ConfigS3Download";
import ConfigS3Archive from "./ConfigS3Archive";
import ConfigReadCredentials from "./ReadCredentials";
import ReadTableConfig from "./ReadTableConfig";
import CloseFileConfig from "./CloseFileConfig";
import KeyboardShortcutConfig from "./KeyboardShortcutConfig";
import ApprovalConfigForm from "./approvalConfig";
import { useHistory } from "react-router-dom";
import CsvConfig from "./CsvConfig";
import ClipboardConfig from "./ClipboradConfig";
import SupervityOCRConfigPanel from "./SupervityOCRConfig";
import ConfigScreenshot from "./ScreenshotConfig";
import HoverConfig from "./HoverConfig";
import DBConfig from "./DBConfig";
import XmlToJsonConfig from "./XmlToJson";
import ChatGptConfig from "./chatGptConfig";
import RagConfig from "./ragConfig";
import ThrowConfig from "./ThrowConfig";
import { useInView } from "react-intersection-observer";

const { Option } = Select;
const imageEditor = React.createRef();

const TEMPLATE_WITH_LOOP_RESTRICTION = [
  "UserDocumentation",
  // "WebAutomation",
  "In-App Walkthrough",
  "UserOnboarding",
  "Desktop Walkthrough",
];

const MAPPPABLE_ACTIONS = ["read", "READFILE", "data-set"];
const GetSkillLabel = (node) => {
  const readOnly = useSelector((state) => state.skillReducer?.readOnly);

  return (
    <div className="rth-tooltip">
      <div className="flex-rth-title">
        <p> Label: </p>
        {readOnly == false ? (
          <Edit
            onClick={(e) => {
              $(`#${node.id}`).toggle();
              e.stopPropagation();
            }}
          />
        ) : null}
      </div>
      <span style={{ fontSize: 12, fontWeight: "400" }}>
        {node.description}
      </span>
      <div
        id={`${node.id}`}
        style={{ display: "none" }}
        className="rth-tooltip"
      >
        <textarea
          rows="1"
          maxlength="50"
          placeholder="Type Something..."
          defaultValue={node.description}
          onBlur={(e) => updateDescription(e.target.value, node.id)}
          onClick={(e) => {
            e.stopPropagation();
          }}
          onChange={(e) => {
            e.target.value = e.target.value.replace(/\n/g, "");
          }}
        ></textarea>
      </div>
    </div>
  );
};

const ErrorHandle = {
  try: null,
  catch: null,
};

const LoopStartDisplay = () => {
  const node = useContext(NodeContext);
  return (
    <div>
      <div className={`stop-node delay-node rt-block-full`}>
        {/* <span style={{ fontSize: 12, fontWeight: 'bold' }}> Description: </span> */}
        <div className="delay-flex">
          <div
            className="stepIconBlock"
            style={{ backgroundColor: "#eff1ff", borderColor: "#9f64ff" }}
          >
            <AllInclusive style={{ color: "#9f64ff" }} />
          </div>
          <div className="delay-text">
            <h4 className="node-titles">Loop start</h4>
          </div>
        </div>
      </div>
    </div>
  );
};

const minimize = (id) => {
  let parent = $(`#${id}`).closest(".try-catch-node")[0];
  $(parent)
    .find(".flow-builder-line__split ")
    .each(function (i, e) {
      $(this).show(500);
    });
  $(parent)
    .find(".flow-builder-action-button")
    .each(function (i, e) {
      $(this).slideToggle(500);
    });

  $(parent)
    .find(".flow-builder-node")
    .each(function (i, e) {
      $(this).slideToggle(500);
    });

  $(parent)
    .find(".mui-icon svg")
    .each(function (i, e) {
      $(this).toggleClass("upDown-rotate");
    });
};

// const expand = (id) => {
//   let parent = $(`#${id}`).closest(".try-catch-node")[0];
//   $(parent)
//     .find(".flow-builder-line__split")
//     .each(function (i, e) {
//       $(this).show(600);
//     });

//     $(parent)
//     .find(".flow-builder-action-button")
//     .each(function (i, e) {
//       $(this).show(600);
//     });

//     $(parent)
//     .find(".flow-builder-node")
//     .each(function (i, e) {
//       $(this).show(600);
//     });
// };

const ReviewTaskNodeDisplay = () => {
  const node = useContext(NodeContext);
  let { rootNodes } = useContext(BuilderContext);
  const readOnly = useSelector((state) => state.skillReducer?.readOnly);

  const { removeNode } = useAction();
  const linkedCallbackNode = node.id.replace("node-start-", "");
  const _removeChild = (ids) => {
    ids.forEach((i) => {
      removeNode(i);
    });
  };
  return (
    <div>
      {node.name == "review-node-start" ? (
        <div className="review-container">
          <Cancel
            className="cancel-button-icon"
            style={{
              color: "#FF6343",
              width: 18,
              height: 18,
              backgroundColor: "white",
              borderRadius: "50%",
            }}
            onClick={() => _removeChild([node.id, linkedCallbackNode])}
          />
          {/* Approval action 1 */}
          <div className="aprove-action-block">
            {/* <h3>Review</h3> */}
            <div className={`delay-node rt-block-full`}>
              <div className="rt-block-header">
                <div className="rth-title">
                  <div className="tl-cont flex-irt">
                    <div
                      className="tl-cont-ico"
                      // style={{ borderColor: "#ff07f5", backgroundColor: "#ffe5fe" }}
                      style={{
                        padding: "0px",
                        borderRadius: "0px",
                        border: "none",
                      }}
                    >
                      <img
                        src={reviewIcon}
                        // style={{ width: "12px" }}
                      />
                    </div>
                    <div className="rth-tl-tp">
                      <p>Review</p>
                    </div>
                    <span
                      className="setting-icon"
                      style={{ textDecoration: "none" }}
                    >
                      Settings
                      <img src={settingIcon} />
                    </span>
                  </div>
                </div>
              </div>

              <div className="rth-tooltip">
                <div className="flex-rth-title">
                  <p> Label: </p>
                  {readOnly == false ? (
                    <Edit
                      onClick={(e) => {
                        $(`#${node.id}`).toggle();
                        e.stopPropagation();
                      }}
                    />
                  ) : null}
                </div>
                <span style={{ fontSize: 12, fontWeight: "400" }}>
                  {node.description}
                </span>
                <div
                  id={`${node.id}`}
                  style={{ display: "none" }}
                  className="rth-tooltip"
                >
                  <textarea
                    rows="1"
                    maxlength="50"
                    placeholder="Type Something..."
                    defaultValue={node.description}
                    onBlur={(e) => updateDescription(e.target.value, node.id)}
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                    onChange={(e) => {
                      e.target.value = e.target.value.replace(/\n/g, "");
                    }}
                  ></textarea>
                </div>
              </div>

              <div className="rtb-screenshot filled-bg">
                <img src={approveActionIcon} alt="pageScreenshot" />
              </div>
            </div>
            {/* <img src={approveActionIcon} /> */}
          </div>
        </div>
      ) : (
        <div>
          <div
            className={`app-review-action review-node-action-${node.name.toLowerCase()}`}
          >
            {/* {node.name} */}
            {node.name === "Approve" ? (
              <img src={approvedIcon} />
            ) : (
              <img src={rejectedIcon} />
            )}
          </div>
        </div>
      )}
    </div>
  );
};

const TryCatchDisplay = () => {
  const node = useContext(NodeContext);
  let { rootNodes } = useContext(BuilderContext);

  const { removeNode } = useAction();
  return (
    <div className="try-catch-container" id={node.id}>
      {!rootNodes.includes(node.id) ? (
        <Cancel
          className="cancel-button-icon"
          style={{ color: "#FF6343", width: 18, height: 18 }}
          onClick={() => removeNode(node.id)}
        />
      ) : null}
      {node.name == "Error Handle" ? (
        <div className={`stop-node delay-node rt-block-full`}>
          <div className="delay-flex">
            <div
              className="stepIconBlock"
              style={{ backgroundColor: "#f4c6c6", borderColor: "#ff0000" }}
            >
              {node.name == "Error Handle" ? (
                <ReportProblem style={{ color: "#ff0000" }} />
              ) : null}
            </div>

            <div className="delay-text">
              {/* <button onClick={() => expand(node.id)}> <UnfoldMore /></button> */}
              <h4 className="node-titles">{node.name}</h4>
              <button className="mui-icon" onClick={() => minimize(node.id)}>
                <ExpandMore />
              </button>
            </div>
          </div>
        </div>
      ) : (
        <div className={`stop-node delay-node rt-block-full`}>
          <div className="delay-flex">
            <div
              className="stepIconBlock"
              style={{ backgroundColor: "#deeffc", borderColor: "#3fa9ff" }}
            >
              <AccountTree style={{ color: "#3fa9ff" }} />
            </div>

            <div className="delay-text">
              {/* <button onClick={() => expand(node.id)}> <UnfoldMore /></button> */}
              <h4 className="node-titles">{node.name}</h4>
              <button className="mui-icon" onClick={() => minimize(node.id)}>
                <ExpandMore />
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const AddDataSetNode = () => {
  const node = useContext(NodeContext);
  return (
    <div className={`delay-node rt-block-full`}>
      <div className="rt-block-header">
        <div className="rth-title">
          <div className="tl-cont flex-irt">
            <div
              className="tl-cont-ico"
              style={{ borderColor: "#00CD9D", backgroundColor: "#b2f7e6" }}
            >
              <Storage
                style={{
                  width: "12px",
                  borderColor: "#00CD9D",
                  backgroundColor: "#b2f7e6",
                  color: "#00CD9D",
                }}
              />
            </div>
            <div className="rth-tl-tp">
              <p>Dataset</p>
            </div>
            <span className="setting-icon" style={{ textDecoration: "none" }}>
              Settings
              <img src={settingIcon} />
            </span>
          </div>
        </div>
      </div>
      {GetSkillLabel(node)}
      <div className="rtb-screenshot filled-bg">
        <img src={folderIcon} alt="pageScreenshot" />
      </div>
    </div>
  );
};

const AddS3Node = () => {
  const node = useContext(NodeContext);
  return (
    <div className={`delay-node rt-block-full`}>
      <div className="rt-block-header">
        <div className="rth-title">
          <div className="tl-cont flex-irt">
            <div
              className="tl-cont-ico"
              style={{ borderColor: "#ff7007", backgroundColor: "#ffe3ce" }}
            >
              <img style={{ width: "12px" }} src={s3ConnectIcon} alt="" />
            </div>
            <div className="rth-tl-tp">
              <p>S3 Connect</p>
            </div>
            <span className="setting-icon" style={{ textDecoration: "none" }}>
              Settings
              <img src={settingIcon} />
            </span>
          </div>
        </div>
      </div>
      {GetSkillLabel(node)}
      <div className="rtb-screenshot filled-bg">
        <img src={s3Connect} alt="pageScreenshot" />
      </div>
    </div>
  );
};
// const AddSMTPNode = () => {
//   const node = useContext(NodeContext);
//   return (
//     <div className={`delay-node rt-block-full`}>
//       <div className="rt-block-header">
//         <div className="rth-title">
//           <div className="tl-cont flex-irt">
//             <div
//               className="tl-cont-ico"
//               style={{ padding: "0px", borderRadius: "0px", border: "none" }}
//             >
//               <img src={smtpIcon} />
//             </div>
//             <div className="rth-tl-tp">
//               <p>SMTP Send Mail</p>
//             </div>
//             <span className="setting-icon"
//               style={{ textDecoration: "none" }}
//             >
//               Settings
//               <img src={settingIcon} />
//             </span>
//           </div>
//         </div>
//       </div>
//       {GetSkillLabel(node)}
//       <div className="rtb-screenshot filled-bg">
//         <img src={smtpImage} alt="pageScreenshot" />
//       </div>
//     </div>
//   );
// };

const AddS3ArchiveNode = () => {
  const node = useContext(NodeContext);
  return (
    <div className={`delay-node rt-block-full`}>
      <div className="rt-block-header">
        <div className="rth-title">
          <div className="tl-cont flex-irt">
            <div
              className="tl-cont-ico"
              style={{ borderColor: "#173bff", backgroundColor: "#eff1ff" }}
            >
              <img style={{ width: "12px" }} src={s3ArchiveIcon} alt="" />
            </div>
            <div className="rth-tl-tp">
              <p>S3 Archive</p>
            </div>
            <span className="setting-icon" style={{ textDecoration: "none" }}>
              Settings
              <img src={settingIcon} />
            </span>
          </div>
        </div>
      </div>
      {GetSkillLabel(node)}
      <div className="rtb-screenshot filled-bg">
        <img src={s3Archive} alt="pageScreenshot" />
      </div>
    </div>
  );
};
const AddS3DownloadNode = () => {
  const node = useContext(NodeContext);
  return (
    <div className={`delay-node rt-block-full`}>
      <div className="rt-block-header">
        <div className="rth-title">
          <div className="tl-cont flex-irt">
            <div
              className="tl-cont-ico"
              style={{ borderColor: "#1d262e", backgroundColor: "#ebebeb" }}
            >
              <img style={{ width: "12px" }} src={s3FileDownloadIcon} alt="" />
            </div>
            <div className="rth-tl-tp">
              <p>S3 File Download</p>
            </div>
            <span className="setting-icon" style={{ textDecoration: "none" }}>
              Settings
              <img src={settingIcon} />
            </span>
          </div>
        </div>
      </div>
      {GetSkillLabel(node)}
      <div className="rtb-screenshot filled-bg">
        <img src={s3Download} alt="pageScreenshot" />
      </div>
    </div>
  );
};

const ReadCredentialsNode = () => {
  const node = useContext(NodeContext);
  return (
    <div className={`delay-node rt-block-full`}>
      <div className="rt-block-header">
        <div className="rth-title">
          <div className="tl-cont flex-irt">
            <div
              className="tl-cont-ico"
              style={{ backgroundColor: "#fff2f2", borderColor: "#ff3333" }}
            >
              <img style={{ width: "12px" }} src={readCredIcon} alt="" />
            </div>
            <div className="rth-tl-tp">
              <p>Read Credentials</p>
            </div>
            <span className="setting-icon" style={{ textDecoration: "none" }}>
              Settings
              <img src={settingIcon} />
            </span>
          </div>
        </div>
      </div>
      {GetSkillLabel(node)}
      <div className="rtb-screenshot filled-bg">
        <img src={readCred} alt="pageScreenshot" />
      </div>
    </div>
  );
};
const StartNodeDisplay = () => {
  const node = useContext(NodeContext);
  return (
    <div className="start-node">
      <div className="rt-block rt-start">
        <div
          className="rtb-ico"
          style={{
            backgroundColor: "#02ce9d",
            cursor: "default",
          }}
        >
          <img src={arrowDownStart} alt="" />
        </div>
        <div className="rtb-text">
          <p>Start</p>
        </div>
      </div>
    </div>
  );
};

const EndNodeDisplay = () => {
  const node = useContext(NodeContext);
  return (
    <div className="end-node">
      <div className="rt-block rt-end">
        <div
          className="rtb-ico"
          style={{
            backgroundColor: "#ff3333",
            cursor: "default",
          }}
        >
          <span className="circle"></span>
        </div>
        <div className="rtb-text">
          <p>End</p>
        </div>
      </div>
    </div>
  );
};

const NodeDisplay = () => {
  const { ref, inView, entry } = useInView({
    /* Optional options */
    threshold: 0,
    triggerOnce: true,
  });
  const node = useContext(NodeContext);
  const { skillTemplate, skillType } = useContext(BuilderContext);
  const [selectedImage, setSelectedImage] = useState("");
  const skill = useSelector((state) => state.skillReducer.trainDraft);
  const userRole = useSelector(
    (state) => state.organizationReducer?.currentOrgUser
  );
  const readOnly = useSelector((state) => state.skillReducer?.readOnly);

  const [imageUrl, setImageUrl] = useState(null);
  useEffect(() => {
    if (selectedImage) {
      setImageUrl(URL.createObjectURL(selectedImage));
    }
  }, [selectedImage]);

  const removeSaveImageButton = () => {
    const elements = document.getElementsByClassName(
      "tui-image-editor-download-btn"
    );
    while (elements?.length > 0) elements[0].remove();
  };

  // Modal Start
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => {
    setTimeout(() => {
      removeSaveImageButton();
      const imageEditorInstance = imageEditor.current.getInstance();
      imageEditorInstance.ui.shape.options.fill = "#ffbb3b";
    });
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const saveMaskedImage = async (id, imageFileName) => {
    setLoadingMaskedImage(true);
    const imageEditorInstance = imageEditor.current.getInstance();
    const imageUrl = imageEditorInstance.toDataURL();
    await updateImageAfterMask(imageUrl, id, imageFileName);
    saveFlow(skill, skill?.RAW_DATA?.actions);
    setIsModalOpen(false);
    setLoadingMaskedImage(false);
  };

  const [loadingMaskedImage, setLoadingMaskedImage] = useState(false);
  return (
    <>
      {node.name === "show" || node.name === "train" ? (
        <div className="rt-block-full recording-block">
          <div className="rcd-icon">
            <img src={recordIcon} />
          </div>
          <div className="rcd-text">
            <h4>Show</h4>
            <p> Click on Start button to initiate Web/Desktop show process</p>
            <div className="rth-tooltip">
              {node.description ? (
                <span style={{ fontSize: 12, fontWeight: "400" }}>
                  {node.description}
                </span>
              ) : null}{" "}
            </div>
          </div>
          <button
            className="rcd-btn"
            onClick={() => checkChromeExtension(node)}
          >
            <p>Start</p>
            <div
              className="stepIconBlock"
              style={{ backgroundColor: "#fff3ea", borderColor: "#ff7007" }}
            >
              <img src={recordIcon} />
            </div>
          </button>
        </div>
      ) : (
        <div
          className={`rt-block-full other-node ${
            node.configuring ? "node-configuring" : ""
          } ${node.validateStatusError ? "node-status-error" : ""}`}
        >
          <div className="rth-title">
            <div className="tl-cont">
              <div className="rth-tooltip">
                {skill?.TEMPLATE === "Process Discovery" ? (
                  <p className="appInfo">
                    <Tooltip
                      title={node?.origin ? node?.app_name : `${node.tabTitle}`}
                    >
                      {node?.origin ? (
                        <>
                          <img src={AppIcon} alt="app_name" />
                          <span>{node?.app_name}</span>
                        </>
                      ) : (
                        <>
                          <img src={BrowserIcon} alt="browser" />
                          <span>
                            {node?.origin
                              ? node?.app_name
                              : `${node.tabTitle}`.substring(0, 27) + "..."}
                          </span>
                        </>
                      )}
                    </Tooltip>
                  </p>
                ) : null}
                <div className="flex-rth-title">
                  <p> Tooltip: </p>
                  {readOnly == false ? (
                    <Edit onClick={() => $(`#${node.id}`).toggle()} />
                  ) : null}
                </div>
                <span style={{ fontSize: 12, fontWeight: "400" }}>
                  {node.description}
                </span>
                <div
                  id={`${node.id}`}
                  style={{ display: "none" }}
                  className="rth-tooltip"
                >
                  <textarea
                    rows="1"
                    placeholder="Type Something..."
                    defaultValue={node.description}
                    onBlur={(e) => updateDescription(e.target.value, node.id)}
                    onChange={(e) => e.target.value}
                  ></textarea>

                  <div className="rth-upload">
                    <div className="upload-btn-wrapper">
                      <button class="btn btn-rth-upload">
                        <img src={imageIcon} />
                        <input
                          type="file"
                          accept="image/*"
                          onChange={(e) => {
                            setSelectedImage(e.target.files[0]);
                            updateImage(e.target.files[0], node.id);
                          }}
                        ></input>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {node.actionType == "kbd_shortcut" ||
          node.actionType == "kp" ||
          node.actionType == "kbd" ? null : (
            <div className="rtb-screenshot" ref={ref}>
              {node.image ? (
                <>
                  {inView ? (
                    <div className="img-preview-thumb">
                      <img src={node.image} />
                    </div>
                  ) : (
                    null
                  )}
                </>
              ) : null}
              {readOnly == true ? null : (
                <div className="check-mask">
                  <Button type="primary" onClick={showModal}>
                    <img src={imgEditIcon} />
                  </Button>
                </div>
              )}

              <Zoom>
                {inView ? (
                  <img
                    src={selectedImage ? imageUrl : node.pageScreenshot}
                    alt="pageScreenshot"
                  />
                ) : null}
              </Zoom>
            </div>
          )}

          {/* Modal image editor */}
          <div>
            <Modal
              className="image-editor-modal"
              title="Image Editor"
              footer={null}
              open={isModalOpen}
              onCancel={handleCancel}
              width={1000}
              centered
            >
              {loadingMaskedImage ? (
                <div id="saveMaskedImageButton">
                  <button className="btn btn-primary">
                    <div class="sp sp-circle text-light"></div>
                  </button>
                </div>
              ) : (
                <div id="saveMaskedImageButton">
                  <button
                    className="btn  btn-primary"
                    onClick={() =>
                      saveMaskedImage(node.id, node.pageScreenshot)
                    }
                  >
                    Mask Image
                  </button>
                </div>
              )}

              <ImageEditor
                includeUI={{
                  loadImage: {
                    path: selectedImage ? imageUrl : node.pageScreenshot,
                    name: "pageScreenshot",
                  },
                  // theme: myTheme,
                  menu: ["shape"],
                  shape: ["rectangle"],
                  initMenu: "shape",
                  uiSize: {
                    width: "100%",
                    height: "700px",
                  },
                  menuBarPosition: "bottom",
                }}
                cssMaxHeight={650}
                cssMaxWidth={800}
                selectionStyle={{
                  cornerSize: 10,
                  rotatingPointOffset: 70,
                }}
                usageStatistics={false}
                ref={imageEditor}
              />
            </Modal>
          </div>

          {skillTemplate === "In-App Walkthrough" && readOnly == false ? (
            <div class="step-position">
              <div class="manual-step active">
                <div class="ch-switch">
                  <input
                    class="tgl tgl-light"
                    name="isManualStep"
                    id={`${node.id}-mn-step`}
                    type="checkbox"
                    onChange={(e) => toggleManualBtn(e, node.id)}
                    defaultChecked={node.isManualStep ? true : false}
                  />
                  <label class="tgl-btn" for={`${node.id}-mn-step`}></label>
                </div>
                <span class="mn-small-text">Manual Step</span>
              </div>
              {node.isManualStep ? (
                <>
                  <div class="next-btn-mn">
                    <div class="mn-radio">
                      <div class="mnr-item">
                        <input
                          type="radio"
                          id={`${node.id}-yes`}
                          name={node.id}
                          value={true}
                          checked={node.displayNextBtn === true}
                          onChange={(e) =>
                            handleNextButtonChange(e.target, "yes", node.id)
                          }
                        />
                        <label for={`${node.id}-yes`}>Yes</label>
                      </div>
                      <div class="mnr-item">
                        <input
                          type="radio"
                          id={`${node.id}-no`}
                          name={node.id}
                          value={false}
                          checked={node.displayNextBtn === false}
                          onChange={(e) =>
                            handleNextButtonChange(e.target, "no", node.id)
                          }
                        />
                        <label for={`${node.id}-no`}>No</label>
                      </div>
                    </div>
                    <span class="mn-small-text">Display Next Button?</span>
                  </div>
                  {/* <div className="antDropdown">
                    <Select
                      labelInValue
                      defaultValue={node.position ? node.position : "Auto"}
                      style={{
                        width: 75,
                        textAlign: "center",
                      }}
                      onChange={(e) => handleChange(e, node.id)}
                    >
                      <Option value="auto">Auto</Option>
                      <Option value="left">Left</Option>
                      <Option value="right">Right</Option>
                      <Option value="top">Top</Option>
                      <Option value="bottom">Bottom</Option>
                    </Select>
                    <span className="mn-small-text">Position</span>
                  </div> */}
                </>
              ) : null}
            </div>
          ) : null}

          {readOnly == true || skill.TEMPLATE === "UserDocumentation" ? null : (
            <span
              className="setting-icon"
              onClick={() => openAdvancedPanel(node.id)}
            >
              Settings <img src={settingIcon} />
            </span>
          )}
        </div>
      )}
    </>
  );
};

const ConditionNodeDisplay = () => {
  const node = useContext(NodeContext);
  return (
    <div
      className={`rt-block-full condition-node ${
        false ? "node-configuring" : ""
      } ${true ? "node-status-error" : ""}`}
    >
      <div className="rotate-content">
        <h4 className="node-titles">{node.name}</h4>
      </div>
    </div>
  );
};

const StopNodeDisplay = () => {
  const node = useContext(NodeContext);
  return (
    <div className={`stop-node rt-block-full`}>
      <div className="delay-flex">
        <div
          className="stepIconBlock"
          style={{ backgroundColor: "#fff2f2", borderColor: "#ff3333" }}
        >
          <img src={stopIcon} />
        </div>
        <div className="delay-text">
          <h4 className="node-titles">{node.name}</h4>
        </div>
      </div>
    </div>
  );
};

const CloseTabNodeDisplay = () => {
  const node = useContext(NodeContext);
  return (
    <div className={`stop-node rt-block-full`}>
      <div className="delay-flex">
        <div
          className="stepIconBlock"
          style={{ backgroundColor: "#fff2f2", borderColor: "#ff3333" }}
        >
          <img src={closeAppIcon} />
        </div>
        <div className="delay-text">
          <h4 className="node-titles">{node.name}</h4>
        </div>
      </div>
    </div>
  );
};

const AssertNodeDisplay = () => {
  const node = useContext(NodeContext);
  return (
    <div
      className={`assert-block ${false ? "node-configuring" : ""} ${
        true ? "node-status-error" : ""
      }`}
    >
      <div className="rotate-content">
        <h4 className="node-titles">{node.name}</h4>
      </div>
    </div>
  );
};

const DelayNodeDisplay = () => {
  const node = useContext(NodeContext);
  const dispatch = useDispatch();
  const [inputValue, setInputValue] = useState(node.time);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);
  };

  const onBlurHandler = (e) => {
    const value = e.target.value;
    if (value === "") {
      dispatch(notify("error", "Value cannot be empty."));
    } else if (isNaN(value)) {
      dispatch(notify("error", "Please enter valid number."));
    } else {
      updateTime(value, node.id);
    }
  };

  return (
    <div className={`stop-node delay-node rt-block-full`}>
      {/* <span style={{ fontSize: 12, fontWeight: 'bold' }}> Description: </span> */}
      <div className="delay-flex">
        <div
          className="stepIconBlock"
          style={{ backgroundColor: "#eff1ff", borderColor: "#173bff" }}
        >
          <img src={waitIcon} />
        </div>
        <div className="delay-text">
          <h4 className="node-titles">{node.description}</h4>
          <Edit onClick={() => $(`#${node.id}`).toggle()} />
        </div>
      </div>
      <div
        id={node.id}
        style={{ display: "none", marginTop: 10 }}
        className="rth-tooltip"
      >
        <input
          value={inputValue}
          onChange={handleInputChange}
          onBlur={onBlurHandler}
        />
      </div>
    </div>
  );
};

const BreakNodeDisplay = () => {
  const node = useContext(NodeContext);
  return (
    <div className={`stop-node delay-node rt-block-full`}>
      <div className="delay-flex">
        <div
          className="stepIconBlock"
          style={{ backgroundColor: "#eff1ff", borderColor: "#173bff" }}
        >
          <img src={breakIcon} />
        </div>
        <div className="delay-text">
          <h4 className="node-titles">{node.description}</h4>
        </div>
      </div>
      <div
        id={`${node.id}`}
        style={{ display: "none", marginTop: 10 }}
        className="rth-tooltip"
      ></div>
    </div>
  );
};

const ContinueNodeDisplay = () => {
  const node = useContext(NodeContext);
  return (
    <div className={`stop-node delay-node rt-block-full`}>
      <div className="delay-flex">
        <div
          className="stepIconBlock"
          style={{ backgroundColor: "#eff1ff", borderColor: "#173bff" }}
        >
          <img src={continueIcon} />
        </div>
        <div className="delay-text">
          <h4 className="node-titles">{node.description}</h4>
        </div>
      </div>
      <div
        id={`${node.id}`}
        style={{ display: "none", marginTop: 10 }}
        className="rth-tooltip"
      ></div>
    </div>
  );
};

const ClipboradNodeDisplay = () => {
  const node = useContext(NodeContext);
  return (
    <div className={`stop-node rt-block-full`}>
      <div className="delay-flex">
        <div
          className="stepIconBlock"
          style={{ backgroundColor: "#fff2f2", borderColor: "#ff3333" }}
        >
          <img src={closeAppIcon} />
        </div>
        <div className="delay-text">
          <h4 className="node-titles">{node.name}</h4>
        </div>
      </div>
    </div>
  );
};

const ReadValueNodeDisplay = () => {
  const node = useContext(NodeContext);
  return (
    <div className={`delay-node rt-block-full`}>
      <div className="rt-block-header">
        <div className="rth-title">
          <div className="tl-cont flex-irt">
            <div className="tl-cont-ico" style={{ borderColor: "#411bbe" }}>
              <img src={readIcon} style={{ width: "14px" }} />
            </div>
            <div className="rth-tl-tp">
              <p>Read</p>
            </div>
            <span className="setting-icon" style={{ textDecoration: "none" }}>
              Settings
              <img src={settingIcon} />
            </span>
          </div>
        </div>
      </div>
      {GetSkillLabel(node)}
      <div className="rtb-screenshot filled-bg">
        <img
          src={automationIcon}
          alt="pageScreenshot"
          style={{ width: "70%" }}
        />
      </div>
    </div>
  );
};

const MailIntegrationNodeDisplay = () => {
  const node = useContext(NodeContext);
  return (
    <div className={`delay-node rt-block-full`}>
      <div className="rt-block-header">
        <div className="rth-title">
          <div className="tl-cont flex-irt">
            <div className="tl-cont-ico">
              <img src={outlookIcon} style={{ width: "30px" }} />
            </div>
            <div className="rth-tl-tp">
              <p>Outlook Mail</p>
            </div>
            <span className="setting-icon" style={{ textDecoration: "none" }}>
              Settings
              <img src={settingIcon} />
            </span>
          </div>
        </div>
      </div>

      {GetSkillLabel(node)}

      <div className="rtb-screenshot filled-bg">
        <img src={outlookImage} alt="pageScreenshot" />
      </div>
    </div>
  );
};

const FilesNodeDisplay = () => {
  const node = useContext(NodeContext);
  return (
    <div className={`delay-node rt-block-full`}>
      <div className="rt-block-header">
        <div className="rth-title">
          <div className="tl-cont flex-irt">
            <div
              className="tl-cont-ico"
              style={{ borderColor: "#ff7007", backgroundColor: "#ffe3ce" }}
            >
              <img src={filesandfolders} style={{ width: "12px" }} />
            </div>
            <div className="rth-tl-tp">
              <p>Files / Folders</p>
            </div>
            <span className="setting-icon" style={{ textDecoration: "none" }}>
              Settings
              <img src={settingIcon} />
            </span>
          </div>
        </div>
      </div>
      {GetSkillLabel(node)}
      <div className="rtb-screenshot filled-bg">
        <img src={folderIcon} alt="pageScreenshot" />
      </div>
    </div>
  );
};

const SecretNodeDisplay = () => {
  const node = useContext(NodeContext);
  return <div>{null}</div>;
};

const ExcelNodeDisplay = () => {
  const node = useContext(NodeContext);
  return (
    <div className={`delay-node rt-block-full`}>
      {/* <span style={{ fontSize: 12, fontWeight: 'bold' }}> Description: </span> */}
      {/* <div className="delay-flex">
        <div
          className="stepIconBlock"
          style={{ backgroundColor: "#eff1ff", borderColor: "#173bff" }}
        >
          <img src={filesandfolders} />
        </div>
        <div className="delay-text">
          <h4 className="node-titles">{node.description}</h4>
          <Edit onClick={() => $(`#${node.id}`).toggle()} />
        </div>
      </div> */}
      <div className="rt-block-header">
        <div className="rth-title">
          <div className="tl-cont flex-irt">
            <div
              className="tl-cont-ico"
              style={{ borderColor: "#ff7007", backgroundColor: "#ffe3ce" }}
            >
              <img src={excelIcon} style={{ width: "12px" }} />
            </div>
            <div className="rth-tl-tp">
              <p>Excel Actions</p>
            </div>
            <span className="setting-icon" style={{ textDecoration: "none" }}>
              Settings
              <img src={settingIcon} />
            </span>
          </div>
        </div>
      </div>
      {GetSkillLabel(node)}
      <div className="rtb-screenshot filled-bg">
        <img src={automation} alt="pageScreenshot" />
      </div>
    </div>
  );
};

const SupervityOCRNodeDisplay = () => {
  const node = useContext(NodeContext);
  return (
    <div className={`delay-node rt-block-full`}>
      <div className="rt-block-header">
        <div className="rth-title">
          <div className="tl-cont flex-irt">
            <div
              className="tl-cont-ico"
              style={{ backgroundColor: "#eaf5ff", borderColor: "#128fff" }}
            >
              <img
                src={dataExtactionIcon}
                style={{ width: "12px", maxWidth: "initial" }}
              />{" "}
            </div>
            <div className="rth-tl-tp">
              <p>Supervity OCR</p>
            </div>
            <span className="setting-icon" style={{ textDecoration: "none" }}>
              Settings
              <img src={settingIcon} />
            </span>
          </div>
        </div>
      </div>

      {GetSkillLabel(node)}

      <div className="rtb-screenshot filled-bg">
        <img
          src={dataExtactionImg}
          alt="pageScreenshot"
          style={{ "max-width": "75%" }}
        />
      </div>
    </div>
  );
};
const HttpApiNodeDisplay = () => {
  const node = useContext(NodeContext);
  return (
    <div className={`delay-node rt-block-full`}>
      <div className="rt-block-header">
        <div className="rth-title">
          <div className="tl-cont flex-irt">
            <div
              className="tl-cont-ico"
              style={{ borderColor: "#ff07f5", backgroundColor: "#ffe5fe" }}
            >
              <img src={httpApi} style={{ width: "12px" }} />
            </div>
            <div className="rth-tl-tp">
              <p>Service Call</p>
            </div>
            <span className="setting-icon" style={{ textDecoration: "none" }}>
              Settings
              <img src={settingIcon} />
            </span>
          </div>
        </div>
      </div>
      {GetSkillLabel(node)}
      <div className="rtb-screenshot filled-bg">
        <img src={httpApiIcon} alt="pageScreenshot" />
      </div>
    </div>
  );
};

const EchoNodeDisplay = () => {
  const node = useContext(NodeContext);
  return (
    <div className={`delay-node rt-block-full`}>
      <div className="rt-block-header">
        <div className="rth-title">
          <div className="tl-cont flex-irt">
            <div
              className="tl-cont-ico"
              // style={{ borderColor: "#ff07f5", backgroundColor: "#ffe5fe" }}
              style={{ padding: "0px", borderRadius: "0px", border: "none" }}
            >
              <img
                src={echoIcon}
                // style={{ width: "12px" }}
              />
            </div>
            <div className="rth-tl-tp">
              <p>Echo</p>
            </div>
            <span className="setting-icon" style={{ textDecoration: "none" }}>
              Settings
              <img src={settingIcon} />
            </span>
          </div>
        </div>
      </div>

      {GetSkillLabel(node)}
      <div className="rtb-screenshot filled-bg">
        <img src={echoImage} alt="pageScreenshot" />
      </div>
    </div>
  );
};

const TechnologyNodeDisplay = () => {
  const node = useContext(NodeContext);
  return (
    <div className={`delay-node rt-block-full`}>
      <div className="rt-block-header">
        <div className="rth-title">
          <div className="tl-cont flex-irt">
            <div
              className="tl-cont-ico"
              style={{ borderColor: "#e6b921", backgroundColor: "#fff2c4" }}
              //style={{ padding: "0px", borderRadius: "0px", border: "none" }}
            >
              <img src={javascriptIcon} style={{ width: "12px" }} />
            </div>
            <div className="rth-tl-tp">
              <p>Javascript</p>
            </div>
            <span className="setting-icon" style={{ textDecoration: "none" }}>
              Settings
              <img src={settingIcon} />
            </span>
          </div>
        </div>
      </div>
      {GetSkillLabel(node)}
      <div className="rtb-screenshot filled-bg">
        <img src={javascriptImage} alt="pageScreenshot" />
      </div>
    </div>
  );
};

const OpenAppNodeDisplay = () => {
  const node = useContext(NodeContext);
  return (
    <div className={`delay-node rt-block-full`}>
      <div className="rt-block-header">
        <div className="rth-title">
          <div className="tl-cont flex-irt">
            <div
              className="tl-cont-ico"
              style={{ borderColor: "#9f64ff", backgroundColor: "#f2eaff" }}
              //style={{ padding: "0px", borderRadius: "0px", border: "none" }}
            >
              <img src={openAppIcon} style={{ width: "12px" }} />
            </div>
            <div className="rth-tl-tp">
              <p>Open App</p>
            </div>
            <span className="setting-icon" style={{ textDecoration: "none" }}>
              Settings
              <img src={settingIcon} />
            </span>
          </div>
        </div>
      </div>
      {GetSkillLabel(node)}
      <div className="rtb-screenshot filled-bg">
        <img src={openAppImage} alt="pageScreenshot" />
      </div>
    </div>
  );
};

const CloseAppNodeDisplay = () => {
  const node = useContext(NodeContext);
  return (
    <div className={`delay-node rt-block-full`}>
      <div className="rt-block-header">
        <div className="rth-title">
          <div className="tl-cont flex-irt">
            <div
              className="tl-cont-ico"
              style={{ borderColor: "#ff7007", backgroundColor: "#ffe3ce" }}
              //style={{ padding: "0px", borderRadius: "0px", border: "none" }}
            >
              <img src={closeAppIcon} style={{ width: "10px" }} />
            </div>
            <div className="rth-tl-tp">
              <p>Close App</p>
            </div>
            <span className="setting-icon" style={{ textDecoration: "none" }}>
              Settings
              <img src={settingIcon} />
            </span>
          </div>
        </div>
      </div>
      {GetSkillLabel(node)}
      <div className="rtb-screenshot filled-bg">
        <img src={closeAppImage} alt="pageScreenshot" />
      </div>
    </div>
  );
};

const SwitchAppNodeDisplay = () => {
  const node = useContext(NodeContext);
  return (
    <div className={`delay-node rt-block-full`}>
      <div className="rt-block-header">
        <div className="rth-title">
          <div className="tl-cont flex-irt">
            <div
              className="tl-cont-ico"
              style={{ borderColor: "#02b6ce", backgroundColor: "#edfdff" }}
              //style={{ padding: "0px", borderRadius: "0px", border: "none" }}
            >
              <img src={switchAppIcon} style={{ width: "12px" }} />
            </div>
            <div className="rth-tl-tp">
              <p>Switch App</p>
            </div>
            <span className="setting-icon" style={{ textDecoration: "none" }}>
              Settings
              <img src={settingIcon} />
            </span>
          </div>
        </div>
      </div>
      {GetSkillLabel(node)}
      <div className="rtb-screenshot filled-bg">
        <img src={switchAppImage} alt="pageScreenshot" />
      </div>
    </div>
  );
};

const MessageBoxNodeDisplay = () => {
  const node = useContext(NodeContext);
  return (
    <div className={`delay-node rt-block-full`}>
      <div className="rt-block-header">
        <div className="rth-title">
          <div className="tl-cont flex-irt">
            <div
              className="tl-cont-ico"
              // style={{ borderColor: "#ff07f5", backgroundColor: "#ffe5fe" }}
              style={{ padding: "0px", borderRadius: "0px", border: "none" }}
            >
              <img
                src={messageBoxIcon}
                // style={{ width: "12px" }}
              />
            </div>
            <div className="rth-tl-tp">
              <p>Message Box</p>
            </div>
            <span className="setting-icon" style={{ textDecoration: "none" }}>
              Settings
              <img src={settingIcon} />
            </span>
          </div>
        </div>
      </div>

      {GetSkillLabel(node)}

      <div className="rtb-screenshot filled-bg">
        <img src={messageBoxImage} alt="pageScreenshot" />
      </div>
    </div>
  );
};

const ClipboardNodeDisplay = () => {
  const node = useContext(NodeContext);
  return (
    <div className={`delay-node rt-block-full`}>
      <div className="rt-block-header">
        <div className="rth-title">
          <div className="tl-cont flex-irt">
            <div
              className="tl-cont-ico"
              //style={{ backgroundColor: "#fff", borderColor: "#000"  }}
              style={{ padding: "0px", borderRadius: "0px", border: "none" }}
            >
              <img src={clipboardIcon} />
            </div>
            <div className="rth-tl-tp">
              <p>Clipboard</p>
            </div>
            <span className="setting-icon" style={{ textDecoration: "none" }}>
              Settings
              <img src={settingIcon} />
            </span>
          </div>
        </div>
      </div>
      {GetSkillLabel(node)}
      <div className="rtb-screenshot filled-bg">
        <img src={clipboardImg} alt="pageScreenshot" />
      </div>
    </div>
  );
};

const AssignNodeDisplay = () => {
  const node = useContext(NodeContext);

  return (
    <div className={`delay-node rt-block-full`}>
      <div className="rt-block-header">
        <div className="rth-title">
          <div className="tl-cont flex-irt">
            <div
              className="tl-cont-ico"
              style={{ borderColor: "#128fff", backgroundColor: "#eaf5ff" }}
            >
              <img src={assign} style={{ width: "12px" }} />
            </div>
            <div className="rth-tl-tp">
              <p>Assign</p>
            </div>
            <span className="setting-icon" style={{ textDecoration: "none" }}>
              Settings
              <img src={settingIcon} />
            </span>
          </div>
        </div>
      </div>
      {GetSkillLabel(node)}
      <div className="rtb-screenshot filled-bg">
        <img src={assignIcon} alt="pageScreenshot" />
      </div>
    </div>
  );
};

const InvokeSkillNodeDisplay = () => {
  const node = useContext(NodeContext);

  return (
    <div className={`delay-node rt-block-full`}>
      <div className="rt-block-header">
        <div className="rth-title">
          <div className="tl-cont flex-irt">
            <div
              className="tl-cont-ico"
              style={{ borderColor: "#128fff", backgroundColor: "#eaf5ff" }}
            >
              <img src={InvokeSkillIcon} style={{ width: "12px" }} />
            </div>
            <div className="rth-tl-tp">
              {node?.skillName ? (
                <p>{`Invoke Skill - ${node.skillName}`}</p>
              ) : (
                <p>{`Invoke Skill`}</p>
              )}
            </div>
            <span className="setting-icon" style={{ textDecoration: "none" }}>
              Settings
              <img src={settingIcon} />
            </span>
          </div>
        </div>
      </div>
      {GetSkillLabel(node)}
      <div className="rtb-screenshot filled-bg">
        <img src={InvokeSkillImg} alt="pageScreenshot" />
      </div>
    </div>
  );
};

const AddSkillNodeDisplay = () => {
  const node = useContext(NodeContext);

  return (
    <div className={`delay-node rt-block-full`}>
      <div className="rt-block-header">
        <div className="rth-title">
          <div className="tl-cont flex-irt">
            <div
              className="tl-cont-ico"
              style={{ borderColor: "#128fff", backgroundColor: "#eaf5ff" }}
            >
              <img src={skillSetIcon} style={{ width: "12px" }} />
            </div>
            <div className="rth-tl-tp">
              {node?.skillName ? (
                <p>{`Add A Skill - ${node.skillName}`}</p>
              ) : (
                <p>{`Add A Skill`}</p>
              )}
            </div>
            <span className="setting-icon" style={{ textDecoration: "none" }}>
              Settings
              <img src={settingIcon} />
            </span>
          </div>
        </div>
      </div>
      {GetSkillLabel(node)}
      <div className="rtb-screenshot filled-bg">
        <img src={skillSetImage} alt="pageScreenshot" />
      </div>
    </div>
  );
};
const ToDoSkillNodeDisplay = () => {
  const node = useContext(NodeContext);

  return (
    <div className={`delay-node rt-block-full`}>
      <div className="rt-block-header">
        <div className="rth-title">
          <div className="tl-cont flex-irt">
            <div
              className="tl-cont-ico"
              style={{ borderColor: "#128fff", backgroundColor: "#eaf5ff" }}
            >
              <img src={todoIcon} style={{ width: "12px" }} />
            </div>
            <div className="rth-tl-tp">
              {node?.skillName ? (
                <p>{`To Do - ${node.skillName}`}</p>
              ) : (
                <p>{`To Do`}</p>
              )}
            </div>
            <span className="setting-icon" style={{ textDecoration: "none" }}>
              Settings
              <img src={settingIcon} />
            </span>
          </div>
        </div>
      </div>
      {GetSkillLabel(node)}
      {/* <div className="rtb-screenshot filled-bg">
        <img src={InvokeSkillImg} alt="pageScreenshot" />
      </div> */}
    </div>
  );
};

const ReadTableNodeDisplay = () => {
  const node = useContext(NodeContext);

  return (
    <div className={`delay-node rt-block-full`}>
      <div className="rt-block-header">
        <div className="rth-title">
          <div className="tl-cont flex-irt">
            <div
              className="tl-cont-ico"
              style={{ backgroundColor: "#edfdff", borderColor: "#02b6ce" }}
            >
              <img src={readTableIcon} style={{ width: "12px" }} />
            </div>
            <div className="rth-tl-tp">
              <p>Read Table</p>
            </div>
            <span className="setting-icon" style={{ textDecoration: "none" }}>
              Settings
              <img src={settingIcon} />
            </span>
          </div>
        </div>
      </div>
      {GetSkillLabel(node)}
      <div className="rtb-screenshot filled-bg">
        <img src={readTable} alt="pageScreenshot" />
      </div>
    </div>
  );
};

const HoverNodeDisplay = () => {
  const node = useContext(NodeContext);

  return (
    <div className={`delay-node rt-block-full`}>
      <div className="rt-block-header">
        <div className="rth-title">
          <div className="tl-cont flex-irt">
            <div
              className="tl-cont-ico"
              // style={{ backgroundColor: "#edfdff", borderColor: "#02b6ce" }}
              style={{ padding: "0px", borderRadius: "0px", border: "none" }}
            >
              <img src={hoverIcon} />
            </div>
            <div className="rth-tl-tp">
              <p>Hover</p>
            </div>
            <span className="setting-icon" style={{ textDecoration: "none" }}>
              Settings
              <img src={settingIcon} />
            </span>
          </div>
        </div>
      </div>
      {GetSkillLabel(node)}
      <div className="rtb-screenshot filled-bg">
        <img src={hoverIllustration} alt="pageScreenshot" />
      </div>
    </div>
  );
};

const CloseFileNodeDisplay = () => {
  const node = useContext(NodeContext);

  return (
    <div className={`delay-node rt-block-full`}>
      <div className="rt-block-header">
        <div className="rth-title">
          <div className="tl-cont flex-irt">
            <div
              className="tl-cont-ico"
              style={{ backgroundColor: "#fff2f2", borderColor: "#ff3333" }}
            >
              <img src={closeFileIcon} style={{ width: "12px" }} />
            </div>
            <div className="rth-tl-tp">
              <p>Close File</p>
            </div>
            <span className="setting-icon" style={{ textDecoration: "none" }}>
              Settings
              <img src={settingIcon} />
            </span>
          </div>
        </div>
      </div>
      {GetSkillLabel(node)}
      <div className="rtb-screenshot filled-bg">
        <img src={closeFile} alt="pageScreenshot" />
      </div>
    </div>
  );
};

const KeyboardShortcutNodeDisplay = () => {
  const node = useContext(NodeContext);

  return (
    <div className={`delay-node rt-block-full`}>
      <div className="rt-block-header">
        <div className="rth-title">
          <div className="tl-cont flex-irt">
            <div
              className="tl-cont-ico"
              style={{ backgroundgColor: "#f2eaff", borderColor: "#9f64ff" }}
            >
              <img src={keyboardshortCutIcon} style={{ width: "12px" }} />
            </div>
            <div className="rth-tl-tp">
              <p>Keyboard ShortCuts</p>
            </div>
            <span className="setting-icon" style={{ textDecoration: "none" }}>
              Settings
              <img src={settingIcon} />
            </span>
          </div>
        </div>
      </div>
      {GetSkillLabel(node)}
      <div className="rtb-screenshot filled-bg">
        <img src={keyboardshortCut} alt="pageScreenshot" />
      </div>
    </div>
  );
};

const CsvNodeDisplay = () => {
  const node = useContext(NodeContext);
  return (
    <div className={`delay-node rt-block-full`}>
      <div className="rt-block-header">
        <div className="rth-title">
          <div className="tl-cont flex-irt">
            <div
              className="tl-cont-ico"
              style={{ borderColor: "#ff7007", backgroundColor: "#ffe3ce" }}
            >
              <img src={excelIcon} style={{ width: "12px" }} />
            </div>
            <div className="rth-tl-tp">
              <p>CSV Actions</p>
            </div>
            <span className="setting-icon" style={{ textDecoration: "none" }}>
              Settings
              <img src={settingIcon} />
            </span>
          </div>
        </div>
      </div>
      {GetSkillLabel(node)}
      <div className="rtb-screenshot filled-bg">
        <img src={automation} alt="pageScreenshot" />
      </div>
    </div>
  );
};

const checkChromeExtension = (node) => {
  try {
    chrome.runtime.sendMessage(
      process.env.REACT_APP_CHROME_TAB_ID,
      { type: "ping" },
      (response) => {
        if (!response) {
          notificationPopUp();
        } else {
          startRecording(node);
        }
      }
    );
  } catch (error) {
    notificationPopUp();
    console.log("error ", error);
  }
};
const ScreenshotNodeDisplay = () => {
  const node = useContext(NodeContext);
  return (
    <div className={`delay-node rt-block-full`}>
      <div className="rt-block-header">
        <div className="rth-title">
          <div className="tl-cont flex-irt">
            <div
              className="tl-cont-ico"
              style={{ borderColor: "#ff7007", backgroundColor: "#ffe3ce" }}
            >
              <img src={screenShotIcon} style={{ width: "12px" }} />
            </div>
            <div className="rth-tl-tp">
              <p>Screenshot</p>
            </div>
            <span className="setting-icon" style={{ textDecoration: "none" }}>
              Settings
              <img src={settingIcon} />
            </span>
          </div>
        </div>
      </div>
      {GetSkillLabel(node)}
      <div className="rtb-screenshot filled-bg">
        <img src={screenShotImg} alt="pageScreenshot" />
      </div>
    </div>
  );
};
const XmlToJsonNodeDisplay = () => {
  const node = useContext(NodeContext);
  return (
    <div className={`delay-node rt-block-full`}>
      <div className="rt-block-header">
        <div className="rth-title">
          <div className="tl-cont flex-irt">
            <div
              className="tl-cont-ico"
              // style={{ borderColor: "#e6b921", backgroundColor: "#fff2c4" }}
              style={{ padding: "0px", borderRadius: "0px", border: "none" }}
            >
              <img src={xmlIcon} />
            </div>
            <div className="rth-tl-tp">
              <p>XML To JSON</p>
            </div>
            <span className="setting-icon" style={{ textDecoration: "none" }}>
              Settings
              <img src={settingIcon} />
            </span>
          </div>
        </div>
      </div>
      {GetSkillLabel(node)}
      <div className="rtb-screenshot filled-bg">
        <img src={xmlIllustration} alt="pageScreenshot" />
      </div>
    </div>
  );
};

const DBNodeDisplay = () => {
  const node = useContext(NodeContext);
  return (
    <div className={`delay-node rt-block-full`}>
      <div className="rt-block-header">
        <div className="rth-title">
          <div className="tl-cont flex-irt">
            <div
              className="tl-cont-ico"
              // style={{ borderColor: "#ff07f5", backgroundColor: "#ffe5fe" }}
              style={{ padding: "0px", borderRadius: "0px", border: "none" }}
            >
              <img
                src={dbIcon}
                // style={{ width: "12px" }}
              />
            </div>
            <div className="rth-tl-tp">
              <p>Database Action</p>
            </div>
            <span className="setting-icon" style={{ textDecoration: "none" }}>
              Settings
              <img src={settingIcon} />
            </span>
          </div>
        </div>
      </div>

      {GetSkillLabel(node)}
      <div className="rtb-screenshot filled-bg">
        <img src={dbIllustration} alt="pageScreenshot" />
      </div>
    </div>
  );
};
const ChatGptNodeDisplay = () => {
  const node = useContext(NodeContext);
  const dispatch = useDispatch();
  return (
    <div
      className={`delay-node rt-block-full`}
      onClick={() => openChatPanel(node.id)}
    >
      <div className="rt-block-header">
        <div className="rth-title">
          <div className="tl-cont flex-irt">
            <div
              className="tl-cont-ico"
              // style={{ borderColor: "#ff07f5", backgroundColor: "#ffe5fe" }}
              style={{ padding: "0px", borderRadius: "0px", border: "none" }}
            >
              <img
                src={gptIcon}
                // style={{ width: "12px" }}
              />
            </div>
            <div className="rth-tl-tp">
              <p>Generative AI</p>
            </div>
            <span className="setting-icon" style={{ textDecoration: "none" }}>
              Settings
              <img src={settingIcon} />
            </span>
          </div>
        </div>
      </div>

      {GetSkillLabel(node)}
      <div className="rtb-screenshot filled-bg">
        <img src={gptImage} alt="pageScreenshot" />
      </div>
    </div>
  );
};

const RagNodeDisplay = () => {
  const node = useContext(NodeContext);
  const dispatch = useDispatch();
  return (
    <div
      className={`delay-node rt-block-full`}
      onClick={() => openRagPanel(node.id)}
    >
      <div className="rt-block-header">
        <div className="rth-title">
          <div className="tl-cont flex-irt">
            <div
              className="tl-cont-ico"
              // style={{ borderColor: "#ff07f5", backgroundColor: "#ffe5fe" }}
              style={{ padding: "0px", borderRadius: "0px", border: "none" }}
            >
              <img
                src={ragIcon}
                // style={{ width: "12px" }}
              />
            </div>
            <div className="rth-tl-tp">
              <p>RAG</p>
            </div>
          </div>
        </div>
      </div>

      {GetSkillLabel(node)}
      <div className="rtb-screenshot filled-bg">
        <img src={ragImage} alt="pageScreenshot" />
      </div>
    </div>
  );
};

const ThrowNodeDisplay = () => {
  const node = useContext(NodeContext);
  return (
    <div className={`delay-node rt-block-full`}>
      <div className="rt-block-header">
        <div className="rth-title">
          <div className="tl-cont flex-irt">
            <div
              className="tl-cont-ico"
              // style={{ borderColor: "#ff07f5", backgroundColor: "#ffe5fe" }}
              style={{ padding: "0px", borderRadius: "0px", border: "none" }}
            >
              <img
                src={ThrowAction_Icon}
                // style={{ width: "12px" }}
              />
            </div>
            <div className="rth-tl-tp">
              <p>Throw Error</p>
            </div>
            <span className="setting-icon" style={{ textDecoration: "none" }}>
              Settings
              <img src={settingIcon} />
            </span>
          </div>
        </div>
      </div>

      {GetSkillLabel(node)}

      <div className="rtb-screenshot filled-bg">
        <img src={ThrowAction_Illustration} alt="pageScreenshot" />
      </div>
    </div>
  );
};
const startRecording = async (node) => {
  store.dispatch(startTimer(true));
  let {
    skillReducer: { trainDraft },
  } = store.getState();
  let payload;
  if (trainDraft?.TEMPLATE === "Process Discovery") {
    payload = {
      skillId: trainDraft.id,
      markerIndex: 0,
      nodeId: node.id,
      variantId: trainDraft?.revision,
    };
  } else {
    payload = {
      skillId: trainDraft.id,
      markerIndex: 0,
      nodeId: node.id,
    };
  }

  store.dispatch(startRecord(payload));
};

const notificationPopUp = () => {
  Store.addNotification({
    title: "Note: ",
    message:
      "Ohh! Seems you don't have Super browser extension added to your browser. Please add it before creating/using skills.",
    type: "warning",
    insert: "top",
    container: "top-right",
    dismiss: {
      duration: 5000,
      onScreen: true,
    },
  });
  window.setTimeout(function () {
    window.open(
      `https://chrome.google.com/webstore/detail/techforce-ide-extension/${process.env.REACT_APP_CHROME_TAB_ID}`,
      "_blank"
    );
  }, 5000);
};

const updateTime = (value, id) => {
  let {
    skillReducer: { trainDraft },
  } = store.getState();
  let actions = findAndUpdate(trainDraft?.RAW_DATA?.actions, id, {
    time: value,
    description: `Wait ${value} Seconds`,
  });
  store.dispatch(
    setDraft({ ...trainDraft, RAW_DATA: { ...trainDraft.RAW_DATA, actions } })
  );
  $(`#${id}`).toggle();
};

const updateDescription = (value, id) => {
  let {
    skillReducer: { trainDraft },
  } = store.getState();
  let actions = findAndUpdate(trainDraft?.RAW_DATA?.actions, id, {
    description: value,
  });
  store.dispatch(
    setDraft({ ...trainDraft, RAW_DATA: { ...trainDraft.RAW_DATA, actions } })
  );
  $(`#${id}`).toggle();
};

const updateImage = async (file, id) => {
  let {
    skillReducer: { trainDraft },
  } = store.getState();
  let url = await store.dispatch(getFileUrl(file));
  let actions = findAndUpdate(trainDraft?.RAW_DATA?.actions, id, {
    pageScreenshot: url,
  });
  store.dispatch(
    setDraft({ ...trainDraft, RAW_DATA: { ...trainDraft.RAW_DATA, actions } })
  );
  $(`#${id}`).toggle();
};

function dataURItoBlob(dataURI) {
  var binary = atob(dataURI.split(",")[1]);
  var array = [];
  for (var i = 0; i < binary.length; i++) {
    array.push(binary.charCodeAt(i));
  }
  return new Blob([new Uint8Array(array)], { type: "image/png" });
}

const updateImageAfterMask = async (file, id, imageFileName) => {
  let {
    skillReducer: { trainDraft },
  } = store.getState();

  file = dataURItoBlob(file);
  file.lastModifiedDate = new Date();
  imageFileName = imageFileName.split("image/")[1];
  let url = await store.dispatch(updateFileUrl(file, imageFileName));
  let actions = findAndUpdate(trainDraft?.RAW_DATA?.actions, id, {
    pageScreenshot: url,
  });
  store.dispatch(
    setDraft({ ...trainDraft, RAW_DATA: { ...trainDraft.RAW_DATA, actions } })
  );
  $(`#${id}`).toggle();
};

let registerNodes = [
  {
    type: "start",
    name: "start",
    actionType: "start",
    displayComponent: StartNodeDisplay,
    isStart: true,
    addableNodeTypes: ADDABLE_SKILL_TYPES,
  },
  {
    type: "end",
    name: "end",
    actionType: "end",
    displayComponent: EndNodeDisplay,
    isEnd: true,
  },
  {
    type: "addSkillSet",
    name: "Add A Skill",
    actionType: "addSkillSet",
    displayComponent: AddSkillNodeDisplay,
    configComponent: InvokeSkillConfigForm,
    addIcon: (
      <div
        className="stepIconBlock"
        style={{ backgroundColor: "#fff", borderColor: "#000" }}
      >
        <img
          src={skillSetIcon}
          style={{ width: "12px", maxWidth: "initial" }}
        />
      </div>
    ),
    addableNodeTypes: ADDABLE_SKILL_TYPES,
  },
  {
    type: "toDoSkill",
    name: "Add a ToDo",
    actionType: "toDoSkill",
    displayComponent: ToDoSkillNodeDisplay,
    configComponent: ToDoSkillConfigForm,
    addIcon: (
      <div
        className="stepIconBlock"
        style={{ backgroundColor: "#eaf5ff", borderColor: "#128fff" }}
      >
        <img src={todoIcon} style={{ width: "12px", maxWidth: "initial" }} />
      </div>
    ),
    addableNodeTypes: ADDABLE_SKILL_TYPES,
  },
  {
    type: "data-set",
    name: "Add Dataset",
    actionType: "addDataSet",
    displayComponent: AddDataSetNode,
    configComponent: ConfigDataSet,
    deleteConfirmTitle: "Are you sure to delete this action block?",
    addIcon: (
      <div
        className="stepIconBlock"
        style={{ backgroundColor: "#b2f7e6", borderColor: "#00CD9D" }}
      >
        <Storage style={{ color: "#00CD9D" }} />
      </div>
    ),
    addableNodeTypes: ADDABLE_SKILL_TYPES,
  },
  {
    type: "assign",
    name: "Assign",
    actionType: "assign",
    displayComponent: AssignNodeDisplay,
    configComponent: AssignConfig,
    addIcon: (
      <div
        className="stepIconBlock"
        style={{ backgroundColor: "#eaf5ff", borderColor: "#128fff" }}
      >
        <img src={assign} />
      </div>
    ),
    addableNodeTypes: ADDABLE_SKILL_TYPES,
  },

  {
    type: "branch",
    name: "branch",
    actionType: "branch",
    conditionNodeType: "condition",
    deleteConfirmTitle: "Are you sure to delete this action block?",
    addIcon: (
      <div
        className="stepIconBlock"
        style={{ backgroundColor: "#edfdff", borderColor: "#02b6ce" }}
      >
        <img src={branchIcon} />
      </div>
    ),
    addableNodeTypes: ADDABLE_SKILL_TYPES,
  },
  {
    type: "break",
    name: "break",
    actionType: "break",
    displayComponent: BreakNodeDisplay,
    addIcon: (
      <div
        className="stepIconBlock"
        style={{ backgroundColor: "#eaf5ff", borderColor: "#128fff" }}
      >
        <img src={breakIcon} />
      </div>
    ),
    addableNodeTypes: ADDABLE_SKILL_TYPES,
  },
  {
    type: "GET_CLIPBOARD",
    name: "Clipboard",
    actionType: "GET_CLIPBOARD",
    displayComponent: ClipboardNodeDisplay,
    configComponent: ClipboardConfig,
    addIcon: (
      <div
        className="stepIconBlock"
        //style={{ backgroundColor: "#fff", borderColor: "#000" }}
        style={{ padding: "0px", borderRadius: "0px", border: "none" }}
      >
        <img src={clipboardIcon} />
      </div>
    ),
    addableNodeTypes: ADDABLE_SKILL_TYPES,
  },
  {
    type: "CLOSEAPP",
    name: "Close App",
    actionType: "CLOSEAPP",
    displayComponent: CloseAppNodeDisplay,
    configComponent: CloseAppConfig,
    addIcon: (
      <div
        className="stepIconBlock"
        style={{ backgroundColor: "#fff2c4", borderColor: "#e6b921" }}
        //style={{ padding: "0px", borderRadius: "0px", border: "none" }}
      >
        <img src={closeAppIcon} style={{ width: "10px" }} />
      </div>
    ),
    addableNodeTypes: ADDABLE_SKILL_TYPES,
  },
  {
    type: "CLOSE",
    name: "Close File",
    actionType: "CLOSE",
    displayComponent: CloseFileNodeDisplay,
    configComponent: CloseFileConfig,
    addIcon: (
      <div
        className="stepIconBlock"
        style={{ backgroundColor: "#fff2f2", borderColor: "#ff3333" }}
      >
        <img src={closeFileIcon} />
      </div>
    ),
    addableNodeTypes: ADDABLE_SKILL_TYPES,
  },
  {
    type: "closetab",
    name: "Close Tab",
    displayComponent: CloseTabNodeDisplay,
    actionType: "closetab",
    configComponent: null,
    deleteConfirmTitle: "Are you sure to delete this action block?",
    addIcon: (
      <div
        className="stepIconBlock"
        style={{ backgroundColor: "#fff2f2", borderColor: "#ff3333" }}
      >
        <img src={closeAppIcon} />
      </div>
    ),
    addableNodeTypes: ADDABLE_SKILL_TYPES,
  },
  {
    type: "continue",
    name: "continue",
    actionType: "continue",
    displayComponent: ContinueNodeDisplay,
    addIcon: (
      <div
        className="stepIconBlock"
        style={{ backgroundColor: "#eaf5ff", borderColor: "#128fff" }}
      >
        <img src={continueIcon} />
      </div>
    ),
    addableNodeTypes: ADDABLE_SKILL_TYPES,
  },
  {
    type: "CSV_HEADER",
    name: "CSV",
    actionType: "CSV_HEADER",
    displayComponent: CsvNodeDisplay,
    configComponent: CsvConfig,
    addIcon: (
      <div
        className="stepIconBlock"
        style={{ backgroundColor: "#ffe3ce", borderColor: "#ff7007" }}
      >
        <img src={excelIcon} />
      </div>
    ),
    addableNodeTypes: ADDABLE_SKILL_TYPES,
  },

  {
    type: "dbConnection",
    name: "Database Action",
    actionType: "DB_CONNECTION",
    displayComponent: DBNodeDisplay,
    configComponent: DBConfig,
    addIcon: (
      <div
        className="stepIconBlock"
        // style={{ backgroundColor: "#ffe3ce", borderColor: "#ff7007" }}
        style={{ padding: "0px", borderRadius: "0px", border: "none" }}
      >
        <img src={dbIcon} />
      </div>
    ),
    addableNodeTypes: ADDABLE_SKILL_TYPES,
  },

  {
    type: "echo",
    name: "Echo",
    actionType: "ECHO",
    displayComponent: EchoNodeDisplay,
    configComponent: EchoConfig,
    addIcon: (
      <div
        className="stepIconBlock"
        // style={{ backgroundColor: "#ffe3ce", borderColor: "#ff7007" }}
        style={{ padding: "0px", borderRadius: "0px", border: "none" }}
      >
        <img src={echoIcon} />
      </div>
    ),
    addableNodeTypes: ADDABLE_SKILL_TYPES,
  },
  {
    type: "excel",
    name: "Excel",
    actionType: "OPEN_SPREADSHEET",
    displayComponent: ExcelNodeDisplay,
    configComponent: ExcelConfig,
    addIcon: (
      <div
        className="stepIconBlock"
        style={{ backgroundColor: "#ffe3ce", borderColor: "#ff7007" }}
      >
        <img src={excelIcon} />
      </div>
    ),
    addableNodeTypes: ADDABLE_SKILL_TYPES,
  },
  {
    type: "filesandfolders",
    name: "Files/Folders",
    actionType: "readfile",
    displayComponent: FilesNodeDisplay,
    configComponent: FilesFoldersConfig,
    addIcon: (
      <div
        className="stepIconBlock"
        style={{ backgroundColor: "#ffe3ce", borderColor: "#ff7007" }}
      >
        <img src={filesandfolders} />
      </div>
    ),
    addableNodeTypes: ADDABLE_SKILL_TYPES,
  },
  {
    type: "CHAT_GPT",
    name: "Generative AI",
    actionType: "CHAT_GPT",
    displayComponent: ChatGptNodeDisplay,
    // configComponent: ChatGptConfig,
    addIcon: (
      <div
        className="stepIconBlock"
        //style={{ backgroundColor: "#fff", borderColor: "#000" }}
        style={{ padding: "0px", borderRadius: "0px", border: "none" }}
      >
        <img src={gptIcon} />
      </div>
    ),
    addableNodeTypes: ADDABLE_SKILL_TYPES,
  },
  {
    type: "hover",
    name: "hover",
    actionType: "hover",
    displayComponent: HoverNodeDisplay,
    configComponent: HoverConfig,
    addIcon: (
      <div
        className="stepIconBlock"
        // style={{ backgroundColor: "#fff2c4", borderColor: "#e6b921" }}
        style={{ padding: "0px", borderRadius: "0px", border: "none" }}
      >
        <img src={hoverIcon} />
      </div>
    ),
    addableNodeTypes: ADDABLE_SKILL_TYPES,
  },
  {
    type: "TECHNOLOGY",
    name: "Javascript",
    actionType: "TECHNOLOGY",
    displayComponent: TechnologyNodeDisplay,
    configComponent: TechnologyConfig,
    addIcon: (
      <div
        className="stepIconBlock"
        style={{ backgroundColor: "#fff2c4", borderColor: "#e6b921" }}
        //style={{ padding: "0px", borderRadius: "0px", border: "none" }}
      >
        <img src={javascriptIcon} style={{ width: "12px" }} />
      </div>
    ),
    addableNodeTypes: ADDABLE_SKILL_TYPES,
  },
  {
    type: "KEY_STROKES",
    name: "Keyboard ShortCuts",
    actionType: "KEY_STROKES",
    displayComponent: KeyboardShortcutNodeDisplay,
    configComponent: KeyboardShortcutConfig,
    addIcon: (
      <div
        className="stepIconBlock"
        style={{ backgroundgColor: "#f2eaff", borderColor: "#9f64ff" }}
      >
        <img src={keyboardshortCutIcon} />
      </div>
    ),
    addableNodeTypes: ADDABLE_SKILL_TYPES,
  },
  {
    type: "loop-nodes",
    name: "loop-nodes",
    displayComponent: LoopStartDisplay,
    actionType: "loopStart",
    configComponent: LoopConfigPanel,
    deleteConfirmTitle: "Are you sure to delete this action block?",
    addIcon: (
      <div
        className="stepIconBlock"
        style={{ backgroundColor: "#f2eaff", borderColor: "#9f64ff" }}
      >
        <AllInclusive style={{ color: "#9f64ff" }} />
      </div>
    ),
    addableNodeTypes: ADDABLE_SKILL_TYPES,
  },
  {
    type: "loop",
    name: "loop",
    conditionNodeType: "loop-nodes",
    actionType: "loop",
    addConditionIcon: null,
    configComponent: null,
    conditionMaxNum: 1,
    deleteConfirmTitle: "Are you sure to delete this action block?",
    addIcon: (
      <div
        className="stepIconBlock"
        style={{ backgroundColor: "#f2eaff", borderColor: "#9f64ff" }}
      >
        <AllInclusive style={{ color: "#9f64ff" }} />
      </div>
    ),
    addableNodeTypes: ADDABLE_SKILL_TYPES,
  },
  {
    type: "messagebox",
    name: "Message Box",
    actionType: "MESSAGE_BOX",
    displayComponent: MessageBoxNodeDisplay,
    configComponent: MessageBoxConfig,
    addIcon: (
      <div
        className="stepIconBlock"
        // style={{ backgroundColor: "#ffe3ce", borderColor: "#ff7007" }}
        style={{ padding: "0px", borderRadius: "0px", border: "none" }}
      >
        <img src={messageBoxIcon} />
      </div>
    ),
    addableNodeTypes: ADDABLE_SKILL_TYPES,
  },
  {
    type: "OPENAPP",
    name: "Open App",
    actionType: "OPENAPP",
    displayComponent: OpenAppNodeDisplay,
    configComponent: OpenAppConfig,
    addIcon: (
      <div
        className="stepIconBlock"
        style={{ backgroundColor: "#fff2c4", borderColor: "#e6b921" }}
        //style={{ padding: "0px", borderRadius: "0px", border: "none" }}
      >
        <img src={openAppIcon} style={{ width: "12px" }} />
      </div>
    ),
    addableNodeTypes: ADDABLE_SKILL_TYPES,
  },
  {
    type: "sendMail",
    name: "Outlook Mail",
    actionType: "sendMail",
    displayComponent: MailIntegrationNodeDisplay,
    configComponent: SendMailConfigForm,
    addIcon: (
      <div
        className="stepIconBlock"
        style={{ backgroundColor: "#deeef9", borderColor: "#0D75BB" }}
      >
        <img src={outlookIcon} style={{ width: "24px", maxWidth: "initial" }} />
      </div>
    ),
    addableNodeTypes: ADDABLE_SKILL_TYPES,
  },
  {
    type: "RAG",
    name: "RAG",
    actionType: "RAG",
    displayComponent: RagNodeDisplay,
    addIcon: (
      <div
        className="stepIconBlock"
        //style={{ backgroundColor: "#fff", borderColor: "#000" }}
        style={{ padding: "0px", borderRadius: "0px", border: "none" }}
      >
        <img src={ragIcon} />
      </div>
    ),
    addableNodeTypes: ADDABLE_SKILL_TYPES,
  },
  {
    type: "read",
    name: "read",
    actionType: "read",
    displayComponent: ReadValueNodeDisplay,
    configComponent: ReadValueConfig,
    addIcon: (
      <div
        className="stepIconBlock"
        style={{ backgroundColor: "#eff1ff", borderColor: "#411bbd" }}
      >
        <img src={readIcon} />
      </div>
    ),
    addableNodeTypes: ADDABLE_SKILL_TYPES,
  },
  {
    type: "review-node-start",
    name: "review-node-start",
    displayComponent: ReviewTaskNodeDisplay,
    configComponent: ApprovalConfigForm,
    actionType: "review-node-start",
    customRemove: true,
    deleteConfirmTitle: "Are you sure to delete this action block?",
    addIcon: (
      <div
        className="stepIconBlock"
        style={{ backgroundColor: "#f2eaff", borderColor: "#9f64ff" }}
      >
        <img src={reviewIcon} />
        {/* <AllInclusive style={{ color: "#9f64ff" }} /> */}
      </div>
    ),
    addableNodeTypes: [],
  },

  {
    type: "review",
    name: "review",
    conditionNodeType: "review-node",
    actionType: "review",
    addConditionIcon: null,
    configComponent: null,
    conditionMaxNum: 1,
    className: "review-parent",
    deleteConfirmTitle: "Are you sure to delete this action block?",
    addIcon: (
      <div
        className="stepIconBlock"
        style={{ backgroundColor: "#f2eaff", borderColor: "#9f64ff" }}
      >
        <img src={reviewIcon} />
        {/* <AllInclusive style={{ color: "#9f64ff" }} /> */}
      </div>
    ),
    addableNodeTypes: ADDABLE_SKILL_TYPES,
  },

  {
    type: "review-node",
    name: "review-node",
    displayComponent: ReviewTaskNodeDisplay,
    actionType: "review-node",
    customRemove: true,
    deleteConfirmTitle: "Are you sure to delete this action block?",
    addIcon: (
      <div
        className="stepIconBlock"
        style={{ backgroundColor: "#f2eaff", borderColor: "#9f64ff" }}
      >
        <img src={reviewIcon} />
        {/* <AllInclusive style={{ color: "#9f64ff" }} /> */}
      </div>
    ),
    addableNodeTypes: ADDABLE_SKILL_TYPES,
  },

  {
    type: "READ_CREDENTIALS",
    name: "Read Credentials",
    actionType: "READ_CREDENTIALS",
    displayComponent: ReadCredentialsNode,
    configComponent: ConfigReadCredentials,
    deleteConfirmTitle: "Are you sure to delete this action block?",
    addIcon: (
      <div
        className="stepIconBlock"
        style={{ backgroundColor: "#fff2f2", borderColor: "#ff3333" }}
      >
        <img style={{ width: "12px" }} src={readCredIcon} />
      </div>
    ),
    addableNodeTypes: ADDABLE_SKILL_TYPES,
  },
  {
    type: "READ_TABLE",
    name: "Read Table",
    actionType: "READ_TABLE",
    displayComponent: ReadTableNodeDisplay,
    configComponent: ReadTableConfig,
    addIcon: (
      <div
        className="stepIconBlock"
        style={{ backgroundColor: "#edfdff", borderColor: "#02b6ce" }}
      >
        <img src={readTableIcon} />
      </div>
    ),
    addableNodeTypes: ADDABLE_SKILL_TYPES,
  },
  {
    type: "record",
    name: "show",
    actionType: "record",
    displayComponent: NodeDisplay,
    addIcon: (
      <div
        className="stepIconBlock"
        style={{ backgroundColor: "#fff3ea", borderColor: "#ff7007" }}
      >
        <img src={recordIcon} />
      </div>
    ),
    addableNodeTypes: ADDABLE_SKILL_TYPES,
  },
  {
    type: "httpapi",
    name: "Service Call",
    actionType: "httpapi",
    displayComponent: HttpApiNodeDisplay,
    configComponent: HttpApiConfig,
    addIcon: (
      <div
        className="stepIconBlock"
        style={{ backgroundColor: "#ffe5fe", borderColor: "#ff07f5" }}
      >
        <img src={httpApi} />
      </div>
    ),
    addableNodeTypes: ADDABLE_SKILL_TYPES,
  },
  {
    type: "stop",
    name: "stop",
    displayComponent: StopNodeDisplay,
    actionType: "stop",
    configComponent: null,
    deleteConfirmTitle: "Are you sure to delete this action block?",
    addIcon: (
      <div
        className="stepIconBlock"
        style={{ backgroundColor: "#fff2f2", borderColor: "#ff3333" }}
      >
        <img src={stopIcon} />
      </div>
    ),
    addableNodeTypes: [],
  },
  {
    type: "supervityOcr",
    name: "Supervity OCR",
    actionType: "httpapi",
    displayComponent: SupervityOCRNodeDisplay,
    configComponent: SupervityOCRConfigPanel,
    addIcon: (
      <div
        className="stepIconBlock"
        style={{ backgroundColor: "#eaf5ff", borderColor: "#128fff" }}
      >
        <img
          src={dataExtactionIcon}
          style={{ width: "12px", maxWidth: "initial" }}
        />
      </div>
    ),
    addableNodeTypes: ADDABLE_SKILL_TYPES,
  },
  {
    type: "SWITCHAPP",
    name: "Switch App",
    actionType: "SWITCHAPP",
    displayComponent: SwitchAppNodeDisplay,
    configComponent: SwitchAppConfig,
    addIcon: (
      <div
        className="stepIconBlock"
        style={{ backgroundColor: "#fff2c4", borderColor: "#e6b921" }}
        //style={{ padding: "0px", borderRadius: "0px", border: "none" }}
      >
        <img src={switchAppIcon} style={{ width: "12px" }} />
      </div>
    ),
    addableNodeTypes: ADDABLE_SKILL_TYPES,
  },
  // {
  //   type: "SMTP",
  //   name: "SMTP Send Mail",
  //   actionType: "SMTP",
  //   displayComponent: AddSMTPNode,
  //   configComponent: SMTPSendMailConfigForm,
  //   deleteConfirmTitle: "Are you sure to delete this action block?",
  //   addIcon: (
  //     <div
  //       className="stepIconBlock"
  //       style={{ padding: "0px", borderRadius: "0px", border: "none" }}
  //     >
  //       <img src={smtpIcon} />
  //     </div>
  //   ),
  //   addableNodeTypes: ADDABLE_SKILL_TYPES,
  // },
  {
    type: "S3_CONNECT",
    name: "S3 Connect",
    actionType: "S3_CONNECT",
    displayComponent: AddS3Node,
    configComponent: ConfigS3,
    deleteConfirmTitle: "Are you sure to delete this action block?",
    addIcon: (
      <div
        className="stepIconBlock"
        style={{ backgroundColor: " #ffe3ce", borderColor: "#ff7007" }}
      >
        <img src={s3ConnectIcon} />
      </div>
    ),
    addableNodeTypes: ADDABLE_SKILL_TYPES,
  },
  {
    type: "S3_FILE_ARCHIVE",
    name: "S3 File Archive",
    actionType: "S3_FILE_ARCHIVE",
    displayComponent: AddS3ArchiveNode,
    configComponent: ConfigS3Archive,
    deleteConfirmTitle: "Are you sure to delete this action block?",
    addIcon: (
      <div
        className="stepIconBlock"
        style={{ backgroundColor: " #ffe3ce", borderColor: " #173bff" }}
      >
        <img src={s3ArchiveIcon} />
      </div>
    ),
    addableNodeTypes: ADDABLE_SKILL_TYPES,
  },

  {
    type: "S3_FILE_DOWNLOAD",
    name: "S3 File Download",
    actionType: "S3_FILE_DOWNLOAD",
    displayComponent: AddS3DownloadNode,
    configComponent: ConfigS3Download,
    deleteConfirmTitle: "Are you sure to delete this action block?",
    addIcon: (
      <div
        className="stepIconBlock"
        style={{ backgroundColor: "#ebebeb", borderColor: "#1d262e" }}
      >
        <img style={{ width: "12px" }} src={s3FileDownloadIcon} />
      </div>
    ),
    addableNodeTypes: ADDABLE_SKILL_TYPES,
  },

  {
    type: "SCREENSHOT",
    name: "Screenshot",
    actionType: "SCREENSHOT",
    displayComponent: ScreenshotNodeDisplay,
    configComponent: ConfigScreenshot,
    deleteConfirmTitle: "Are you sure to delete this action block?",
    addIcon: (
      <div
        className="stepIconBlock"
        style={{ backgroundColor: "#ebebeb", borderColor: "#1d262e" }}
      >
        <img style={{ width: "12px" }} src={screenShotIcon} />
      </div>
    ),
    addableNodeTypes: ADDABLE_SKILL_TYPES,
  },
  {
    type: "GET_AZURESECRET",
    name: "Get Secret",
    actionType: "GET_AZURESECRET",
    displayComponent: SecretNodeDisplay,
    configComponent: null,
    addIcon: (
      <div
        className="stepIconBlock"
        style={{ backgroundColor: "#eaf5ff", borderColor: "#128fff" }}
      >
        <img src={assign} />
      </div>
    ),
    addableNodeTypes: [],
  },
  {
    type: "try",
    name: "try",
    conditionNodeType: "try-catch-node",
    actionType: "try",
    addConditionIcon: null,
    configComponent: null,
    conditionMaxNum: 1,
    customRemove: false,
    className: "try-catch-parent try-catch-parent-verbose",
    deleteConfirmTitle: "Are you sure to delete this action block?",
    addIcon: (
      <div
        className="stepIconBlock"
        style={{ backgroundColor: "#f2eaff", borderColor: "#9f64ff" }}
      >
        <AllInclusive style={{ color: "#9f64ff" }} />
      </div>
    ),
    addableNodeTypes: ADDABLE_SKILL_TYPES,
  },

  {
    type: "try-catch-node",
    name: "try-catch-node",
    className: "try-catch-node try-catch-node-verbose",
    displayComponent: TryCatchDisplay,
    actionType: "try-catch-node",
    customRemove: true,
    configComponent: null,
    deleteConfirmTitle: "Are you sure to delete this action block?",
    addIcon: (
      <div
        className="stepIconBlock"
        style={{ backgroundColor: "#f2eaff", borderColor: "#9f64ff" }}
      >
        <AllInclusive style={{ color: "#9f64ff" }} />
      </div>
    ),
    addableNodeTypes: ADDABLE_SKILL_TYPES,
  },
  {
    type: "condition",
    name: "condition",
    actionType: "condition",
    displayComponent: ConditionNodeDisplay,
    configComponent: ConfigPanel,
    deleteConfirmTitle: "Are you sure to delete this action block?",
    configTitle: "Configure Condition",
    addableNodeTypes: ADDABLE_SKILL_TYPES,
  },
  {
    type: "wait",
    name: "wait",
    actionType: "wait",
    displayComponent: DelayNodeDisplay,
    configComponent: null,
    addIcon: (
      <div
        className="stepIconBlock"
        style={{ backgroundColor: "#eff1ff", borderColor: "#173bff" }}
      >
        <img src={waitIcon} />
      </div>
    ),
    addableNodeTypes: ADDABLE_SKILL_TYPES,
  },
  {
    type: "XML_TO_JSON",
    name: "XML to JSON",
    actionType: "XML_TO_JSON",
    displayComponent: XmlToJsonNodeDisplay,
    configComponent: XmlToJsonConfig,
    addIcon: (
      <div
        className="stepIconBlock"
        // style={{ backgroundColor: "#fff2c4", borderColor: "#e6b921" }}
        style={{ padding: "0px", borderRadius: "0px", border: "none" }}
      >
        <img src={xmlIcon} />
      </div>
    ),
    addableNodeTypes: ADDABLE_SKILL_TYPES,
  },
  {
    type: "THROW",
    name: "Throw Error",
    actionType: "THROW",
    displayComponent: ThrowNodeDisplay,
    configComponent: ThrowConfig,
    addIcon: (
      <div
        className="stepIconBlock"
        // style={{ backgroundColor: "#fff2c4", borderColor: "#e6b921" }}
        style={{ padding: "0px", borderRadius: "0px", border: "none" }}
      >
        <img src={ThrowAction_Icon} />
      </div>
    ),
    addableNodeTypes: ADDABLE_SKILL_TYPES,
  },
];

const findAndAdd = (arr, id, payload) => {
  let found = arr.findIndex((i) => i.id == id);
  if (found > -1) {
    arr.splice(found, 0, payload);
    // arr[found] = { ...arr[found], ...payload };
  } else {
    arr.forEach((element) => {
      if (
        [
          "branch",
          "condition",
          "loop",
          "loop-nodes",
          "try",
          "try-catch-node",
          "review",
          "review-node",
        ].includes(element.type)
      ) {
        return findAndAdd(element.children, id, payload);
      }
    });
  }
  return arr;
};

const findAndUpdate = (arr, id, payload) => {
  let found = arr.findIndex((i) => i.id == id);
  if (found > -1) {
    arr[found] = { ...arr[found], ...payload };
  } else {
    arr.forEach((element) => {
      if (
        [
          "branch",
          "condition",
          "loop",
          "loop-nodes",
          "try",
          "try-catch-node",
          "review",
          "review-node",
        ].includes(element.type)
      ) {
        return findAndUpdate(element.children, id, payload);
      }
    });
  }
  return arr;
};

const findEle = (arr, id) => {
  let result;
  arr.some(
    (child) =>
      (child.id === id && (result = child)) ||
      (result = findEle(child.children || [], id))
  );
  return result;
};

const findAndRemove = (arr, id) => {
  let found = arr.findIndex((i) => i.id === id);
  if (found > -1) {
    arr.splice(found, 1);
  } else {
    arr.forEach((element) => {
      if (
        [
          "branch",
          "condition",
          "loop",
          "loop-nodes",
          "try",
          "try-catch-node",
          "review",
          "review-node",
        ].includes(element.type)
      ) {
        findAndRemove(element.children, id);
      }
    });
  }
  return arr;
};

const handleChange = (value, nodeId) => {
  let {
    skillReducer: { trainDraft },
  } = store.getState();
  let actions = findAndUpdate(trainDraft?.RAW_DATA?.actions, nodeId, {
    position: value.value,
  });
  store.dispatch(
    setDraft({ ...trainDraft, RAW_DATA: { ...trainDraft.RAW_DATA, actions } })
  );
};

const handleNextButtonChange = (e, type, id) => {
  let val = type === "yes" && e.checked;
  let {
    skillReducer: { trainDraft },
  } = store.getState();
  let actions = findAndUpdate(trainDraft?.RAW_DATA?.actions, id, {
    displayNextBtn: val,
  });
  store.dispatch(
    setDraft({ ...trainDraft, RAW_DATA: { ...trainDraft.RAW_DATA, actions } })
  );
};

const toggleManualBtn = (e, id) => {
  let {
    skillReducer: { trainDraft },
  } = store.getState();
  let actions = findAndUpdate(trainDraft?.RAW_DATA?.actions, id, {
    isManualStep: e.target.checked,
  });
  store.dispatch(
    setDraft({ ...trainDraft, RAW_DATA: { ...trainDraft.RAW_DATA, actions } })
  );
};

const removeHtmlTags = (html) => {
  const tmp = document.createElement("div");
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || "";
};

const saveAdvancedConfig = (values, id, shouldClose = true) => {
  let {
    skillReducer: { trainDraft },
  } = store.getState();
  const sanitizedDescription = removeHtmlTags(trainDraft?.SKILL_DESCRIPTION);
  if (values?.image) {
    let actions = findAndUpdate(trainDraft?.RAW_DATA?.actions, id, {
      image: values.image,
    });
    store.dispatch(
      setDraft({ ...trainDraft, RAW_DATA: { ...trainDraft.RAW_DATA, actions } })
    );
  }

  let formatData = trainDraft.FORMATED_DATA;
  formatData.actions[id] = { ...formatData.actions[id], ...values };
  store.dispatch(setDraft({ ...trainDraft, FORMATED_DATA: formatData }));

  if (trainDraft?.TEMPLATE === "Process Discovery") {
    store.dispatch(
      updateDraftSkill(trainDraft.id, {
        ...trainDraft,
        FORMATED_DATA: formatData,
        SKILL_DESCRIPTION: sanitizedDescription,
        variantId: trainDraft?.revision,
      })
    );
  } else {
    store.dispatch(
      updateDraftSkill(trainDraft.id, {
        ...trainDraft,
        FORMATED_DATA: formatData,
        SKILL_DESCRIPTION: sanitizedDescription,
      })
    );
  }

  // store.dispatch(closeAdvancedConfigPanel());
};

const openAdvancedPanel = (id) => {
  let {
    skillReducer: { trainDraft },
  } = store.getState();
  let formatedData = trainDraft.FORMATED_DATA.actions[id];
  store.dispatch(
    setAdvancedConfigPanel({ ...formatedData, panelVisible: true })
  );
};

const saveChatConfig = (values, id, shouldClose = true) => {
  let {
    skillReducer: { trainDraft },
  } = store.getState();

  const sanitizedDescription = removeHtmlTags(trainDraft?.SKILL_DESCRIPTION);

  let formatData = trainDraft.FORMATED_DATA;
  formatData.actions[id] = { ...formatData.actions[id], ...values };
  store.dispatch(setDraft({ ...trainDraft, FORMATED_DATA: formatData }));
  if (trainDraft?.TEMPLATE === "Process Discovery") {
    store.dispatch(
      updateDraftSkill(trainDraft.id, {
        ...trainDraft,
        FORMATED_DATA: formatData,
        SKILL_DESCRIPTION: sanitizedDescription,
        variantId: trainDraft?.revision,
      })
    );
  } else {
    store.dispatch(
      updateDraftSkill(trainDraft.id, {
        ...trainDraft,
        FORMATED_DATA: formatData,
        SKILL_DESCRIPTION: sanitizedDescription,
      })
    );
  }

  // store.dispatch(closeAdvancedConfigPanel());
};

const openChatPanel = (id) => {
  let {
    skillReducer: { trainDraft },
  } = store.getState();
  let formatedData = trainDraft?.FORMATED_DATA?.actions[id];
  store.dispatch(setChatPanel({ data: formatedData, panelVisible: true }));
};
const openRagPanel = (id) => {
  let {
    skillReducer: { trainDraft },
  } = store.getState();
  let formatedData = trainDraft.FORMATED_DATA.actions[id];
  store.dispatch(setRagPanel({ data: formatedData, panelVisible: true }));
};
const getNode = (type, child = false) => {
  return {
    id: uuid(),
    type: type,
    name: type,
    actionType: type,
    children: child ? [] : undefined,
    isStart: type === "start",
    isEnd: type === "end",
  };
};

const getScreenshotNode = (time) => {
  return {
    actionType: "SCREENSHOT",
    label: "Screenshot",
    key: "screenshot",
    filePath: "",
    instruction: "",
    description: "",
    status: true,
    breakpoint: false,
  };
};

const getWaitNode = (time) => {
  return {
    actionType: "wait",
    label: "Wait",
    key: "wait",
    time: time,
    allowNesting: false,
    description: `Wait ${time} Seconds`,
    status: true,
    breakpoint: false,
    instruction: "wait 1",
  };
};

const getContinueNode = () => {
  return {
    actionType: "continue",
    label: "Statements",
    key: "continue",
    allowNesting: false,
    statement: "continue",
    variableName: "",
    instruction: "continue",
    status: true,
    breakpoint: false,
    description: "Continue",
  };
};

const getBreakNode = () => {
  return {
    actionType: "break",
    label: "Statements",
    key: "break",
    allowNesting: false,
    statement: "break",
    variableName: "",
    instruction: "break",
    status: true,
    breakpoint: false,
    description: "Break",
  };
};
const getCloseTabNode = () => {
  return {
    actionType: "closetab",
    label: "Close Tab",
    key: "closetab",
    allowNesting: false,
    statement: "closetab",
    variableName: "",
    instruction: "close tab",
    breakpoint: false,
  };
};

const getLoopNodes = () => {
  return {
    actionType: "loop",
    label: "Loop",
    key: "loop",
    allowNesting: false,
    description: `Loop`,
    status: true,
    breakpoint: false,
    children: [
      {
        actionType: "wait",
        label: "Wait",
        key: "wait",
        time: 1,
        allowNesting: false,
        description: `Wait ${1} Seconds`,
        status: true,
        breakpoint: false,
        instruction: "wait 1",
      },
    ],
  };
};

const getReadNode = () => {
  return {
    actionType: "read",
    label: "read",
    key: "read",
    status: true,
    readFromElement: "",
    readToVariable: "",
    instruction: "",
  };
};

const getExcelActionNode = () => {
  return {
    actionType: "OPEN_SPREADSHEET",
    label: "Excel",
    key: "excel",
    instruction: "",
    description: "",
    status: true,
  };
};

const getFilesAndFolderNode = () => {
  return {
    actionType: "",
    label: "Files/Folders",
    key: "filesandfolders",
    instruction: "",
    description: "",
    ifCondition: "files",
    dates: "static",
    extractToSameLocation: false,
    status: true,
  };
};

const getHttpApiNode = () => {
  return {
    actionType: "HTTP",
    label: "HTTP API",
    key: "httpapi",

    reqBody: "",
    method: "GET",
    body: false,
    url: "",
    headers: false,
    apiHeaders: [
      {
        id: 1,
        headerKey: "Content-Type",
        headerValue: "application/json",
        keyId: 1.1,
      },
    ],
    variableName: "",
    instruction:
      "api_config = { method:'POST', header:[\"Content-Type:application/json\"],body:{}}\napi sds\necho api_result\necho api_json",

    description: "",
    apiFileAttachments: "",
    status: true,
    attachments: false,
  };
};

const getSupervityOCRNode = () => {
  return {
    actionType: "HTTP",
    label: "HTTP API",
    key: "httpapi",

    reqBody: '{"name":"Your <Filename> goes here"}',
    method: "POST",
    body: true,
    url: "https://ocrtf-apimgmt.azure-api.net/ocr-techforce/ExtractData",
    headers: true,
    apiHeaders: [
      {
        id: 1,
        headerKey: "Content-Type",
        headerValue: "application/json",
        keyId: 1.1,
      },
      {
        id: 2,
        keyId: 2,
        headerKey: "Ocp-Apim-Subscription-Key",
        headerValue: "",
      },
    ],
    variableName: "",
    instruction:
      "api_config = { method:'POST', header:[\"Content-Type:application/json\"],body:{}}\napi sds\necho api_result\necho api_json",

    description: "",
    apiFileAttachments: "",
    status: true,
    attachments: false,
    isOCR: true,
  };
};

const getSMTPNode = () => {
  return {
    actionType: "SEND_SMTP_MAIL",
    label: "Send SMTP Mail",
    key: "sendSmtpMail",
    subActions: [],
    allowNesting: true,
    to: "",
    email: "",
    subject: "",
    body: "",
    cc: "",
    bcc: "",
    attachments: "",
    api: "http://localhost:5555/v1/rpa/metadata/smtp/sendMail",
    description: "",
    password: "",
    host: "",
    port: "",
  };
};

const getAssignNode = () => {
  return {
    actionType: "ASSIGN",
    label: "Assign",
    key: "assign",
    description: "",
  };
};

const connectS3Node = () => {
  return {
    actionType: "S3_CONNECT",
    label: "S3 Connection",
    key: "s3connection",
    description: "",
    allowNesting: false,
    accessKey: "",
    secretKey: "",
    status: true,
    breakpoint: false,
    instruction: "Connect to S3",
    description: "",
  };
};
const downloadS3Node = () => {
  return {
    actionType: "S3_FILE_DOWNLOAD",
    label: "Download File",
    key: "s3downloadfile",
    description: "",
    allowNesting: false,
    bucketName: "",
    folderPath: "",
    keyName: "",
    status: true,
    breakpoint: false,
    instruction: "download s3 file",
    description: "",
    Region: "", //(mandate)
    Archive: false, //(optional)
    ArchiveToBucketName: "", //(optional)
    ArchiveKeyName: "", //(optional)
  };
};

const connectS3ArchiveNode = () => {
  return {
    actionType: "S3_FILE_ARCHIVE",
    label: "Archive File",
    key: "s3archivefile",
    description: "",
    allowNesting: false,
    status: true,
    sourceBucketName: "", //(mandate)
    sourceKeyName: "", //(mandate)
    breakpoint: false,
    instruction: "archive s3 file",
    description: "",
    Region: "", //(mandate)
    destinationBucketName: "", //(mandate)
    destinationKeyName: "", //(optional)
  };
};
const getSendMailNode = () => {
  return {
    actionType: "sendOutlookMail",
    label: "sendOutlookMail",
    key: "sendOutlookMail",
    subActions: [],
    allowNesting: true,
    // to: "",
    // subject: "",
    // body: "",
    // cc: "",
    // bcc: "",
    // attachments: "",
    api: "http://localhost:8002/api/v1/sendMail",
    description: "",
    status: true,
    breakpoint: false,
    instruction: "",
  };
};

const getCallbackNode = (id) => {
  id = id.replace("review-", "");
  return {
    id: `review-node-start-${id}`,
    actionType: "review-node-start",
    type: "review-node-start",
    name: "review-node-start",
  };
};

const getInvokeSkillNode = () => {
  return {
    actionType: "invokeSkill",
    label: "invokeSkill",
    key: "invokeSkill",
    status: true,
    description: "",
    instruction: "",
    skillId: "",
    skillName: "",
  };
};
const getToDoSkillNode = () => {
  return {
    actionType: "invokeSkill",
    label: "invokeSkill",
    key: "invokeSkill",
    status: true,
    description: "",
    instruction: "",
    skillId: "",
    skillName: "",
  };
};
const getAddSkillNode = () => {
  return {
    actionType: "invokeSkill",
    label: "invokeSkill",
    key: "invokeSkill",
    status: true,
    description: "",
    instruction: "",
    skillId: "",
    skillName: "",
  };
};

const readCredentialsNode = () => {
  return {
    actionType: "READ_CREDENTIALS",
    label: "Read Credentials",
    key: "ReadCredentials",
    allowNesting: false,
    CredName: "",
    variable: "",
    UserName: "",
    Password: "",
    variableName: "",
    instruction: "",
    status: true,
    description: "",
    newdescription: "read credentials",
  };
};

const readTableNode = () => {
  return {
    actionType: "READ_TABLE",
    label: "Read Table",
    key: "readtable",
    subActions: [],
    allowNesting: false,
    description: "",
    variableName: "",
    instruction: "",
    iframe_name: "",
    status: true,
    breakpoint: false,
  };
};

const closeFileNode = () => {
  return {
    actionType: "CLOSE",
    label: "Close File",
    key: "close",
    description: "",
    instruction: "",
    status: true,
    breakpoint: false,
  };
};

const clipboardNode = () => {
  return {
    actionType: "GET_CLIPBOARD",
    label: "Clipboard",
    key: "clipboard",
    description: "",
    instruction: "",
    variable: "",
    status: true,
    breakpoint: false,
  };
};

const keyboardShortcutNode = () => {
  return {
    actionType: "KEY_STROKES",
    label: "Keyboard ShortCuts",
    key: "keyboardshortcuts",
    description: "",
    instruction: "",
    status: true,
    breakpoint: false,
  };
};

const csvHeaderNode = () => {
  return {
    actionType: "CSV",
    label: "",
    key: "",
    CsvFileName: "",
    value: [],
    allowNesting: false,
    description: "",
    variableName: "",
    instruction: "",
    status: true,
    breakpoint: false,
  };
};
const csvRowNode = () => {
  return {
    actionType: "CSV_ROW",
    label: "CSV Row",
    key: "csvrow",
    CsvFileName: "",
    CsvArray: "",
    subActions: [],
    allowNesting: false,
    description: "",
    variableName: "",
    instruction: "",
    status: true,
    breakpoint: false,
  };
};

const getHoverNode = () => {
  return {
    actionType: "hover",
    label: "Hover",
    key: "hover",
    allowNesting: false,
    selector: "",
    selectorType: "",
    imgSelector: "",
    instruction: "",
    status: true,
    breakpoint: false,
    description: "",
    instruction: "",
  };
};
const getXmlToJsonNode = () => {
  return {
    actionType: "XML_TO_JSON",
    label: "XML To JSON",
    key: "XmlToJson",
    allowNesting: false,
    selector: "",
    selectorType: "",
    imgSelector: "",
    status: true,
    breakpoint: false,
    description: "",
    instruction: "",
    jsonVariable: "",
    xmlFilePath: "",
    xmlText: "",
    xmlVarName: "",
    selectType: "",
  };
};

const getDBNode = () => {
  return {
    actionType: "",
    label: "",
    key: "",
    allowNesting: true,
    subActions: [],
    db_type: "",
    db_token: "",
    host: "",
    port: "",
    databasename: "",
    password: "",
    showPassword: false,
    username: "",
    status: true,
    breakpoint: false,
    sid: "",
    servicename: "",
    selectorType: "",
    isFIPS: false,
    instruction: "",
    query: "",
    variable: "",
    withColumns: false,

    description: "",
  };
};

const getGptNode = () => {
  return {
    actionType: "CHAT_GPT",
    label: "Generative AI",
    key: "chatGpt",
    allowNesting: true,
    messages: [
      {
        role: "system",
        content: "",
      },
      {
        role: "user",
        content: "",
      },
    ],
    model: "gpt-3.5-turbo",
    temperature: 1,
    max_tokens: 1024,
    top_p: 1,
    frequency_penalty: 0,
    presence_penalty: 0,
    status: true,
    breakpoint: false,
    instruction: "",
    variable: "", //To store chatGpt response
    description: "",
  };
};

const getRagNode = () => {
  return {
    actionType: "RAG",
    label: "Rag",
    key: "rag",
    allowNesting: true,
    messages: [
      {
        role: "user",
        content: "",
      },
    ],
    model: "",
    status: true,
    breakpoint: false,
    instruction: "",
    variable: "",
    description: "",
  };
};

const getThrowNode = () => {
  return {
    actionType: "THROW",
    label: "throw",
    key: "throw",
    allowNesting: false,
    instruction: "",
    status: true,
    breakpoint: false,
    description: "",
    instruction: "",
    errorMsg: "",
  };
};
const getRearrangedData = (actions) => {
  let temp = [];
  temp.push(getNode("start"));
  actions.forEach((a, i) => {
    if (!a.type) {
      a.type = a.actionType;
      temp.push(a);
    } else {
      temp.push(a);
    }
  });
  temp.push(getNode("end"));
  return temp;
};
const flatten = (arr, _arr) => {
  arr.forEach((i) => {
    if (
      [
        "branch",
        "condition",
        "loop",
        "loop-nodes",
        "try",
        "try-catch-node",
        "review",
        "review-node",
      ].includes(i.type)
    ) {
      let ele = {
        id: i.id,
        type: i.type,
        name: i.name,
        actionType: i.actionType,
        next: i.children.map((i) => i.id),
      };
      _arr.push(ele);
      flatten(i.children, _arr);
    } else {
      let ele = {
        id: i.id,
        type: i.type,
        name: i.name,
        actionType: i.actionType,
        next: [],
      };
      _arr.push(ele);
    }
  });
  return _arr;
};
const findDiff = (arr1, arr2, type) => {
  let obj1, obj2, diff;
  if (arr1?.length !== arr2?.length) {
    diff = _.differenceWith(arr2, arr1, _.isEqual).filter(
      (i) => i.type === type
    )[0];
  } else {
    obj1 = flatten(arr1, []);
    obj2 = flatten(arr2, []);
    diff = _.differenceWith(obj2, obj1, _.isEqual).filter(
      (i) => i.type === type
    )[0];
    diff = findEle(arr2, diff.id);
  }
  return diff;
};

const getFlowVars = (actions) => {
  let vars = actions
    .filter((i) => i.xPath && i.actionType !== "click")
    .map((i) => {
      return {
        xPath: i.xPath,
        pageScreenshot: i.pageScreenshot,
        name: i.name,
        value: i.value,
        id: i.id,
      };
    });
  return vars;
};

const getDataSetChildVars = (actions, childVar) => {
  actions.forEach((action) => {
    if (
      [
        "branch",
        "condition",
        "loop",
        "loop-nodes",
        "try",
        "try-catch-node",
        "review",
        "review-node",
      ].includes(action.type)
    ) {
      getDataSetChildVars(action?.children, childVar);
    }
    if (action.type === "data-set") {
      let _datavar = {
        id: action.id,
        ...action.data,
      };
      childVar.push(_datavar);
    }
  });
  return childVar;
};

const getDatasetVars = (actions) => {
  let _allVar = [];
  actions.forEach((action) => {
    if (
      [
        "branch",
        "condition",
        "loop",
        "loop-nodes",
        "try",
        "try-catch-node",
        "review",
        "review-node",
      ].includes(action.type)
    ) {
      let childData = getDataSetChildVars(action?.children, []);
      _allVar = _allVar.concat(childData);
    }
    if (action.type === "data-set") {
      let _datavar = {
        id: action.id,
        ...action.data,
      };
      _allVar.push(_datavar);
    }
  });

  return _allVar;
};

const getGlobalVars = (actions) => {
  let vars = actions
    .filter((i) => MAPPPABLE_ACTIONS.includes(i.actionType || i.type))
    ?.map((i) => {
      return {
        id: i.id,
        name: i.name,
        variable: i.variable || i.readToVariable,
      };
    });
  return vars;
};

const getRootNodes = (actions) => {
  if (actions.length && actions[0]?.children) {
    return actions[0]?.children.map((i) => i.id);
  } else {
    return [];
  }
};

const saveFlow = (skill, actions) => {
  var rawData = {
    ...skill?.RAW_DATA,
    actions: actions,
  };
  var status = skill.status;
  let skillName = skill.SKILL_NAME;
  let updatedData;
  if (skill.TEMPLATE === "Process Discovery") {
    updatedData = {
      status,
      skillName,
      rawData,
      itemId: skill.id,
      variantId: skill?.revision,
    };
  } else {
    updatedData = { status, skillName, rawData, itemId: skill.id };
  }
  store.dispatch(updateFormatedData(updatedData));
};

const NodeForm = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const params = useParams();
  const [nodes, setNodes] = useState([]);
  const [customClassName, setCustomClassName] = useState("");
  const [flowVars, setFlowVars] = useState([]);
  const [datasetVars, setDatasetVars] = useState([]);
  const [globalVars, setGlobalVars] = useState({});

  const [loader, setLoader] = useState(false);
  let [validNodes, setValidNodes] = useState(registerNodes);
  const [showConfigPanel, setShowConfigPanel] = useState(false);
  const [showVariablesPanel, setShowVariablesPanel] = useState(false);
  const [showChatPanel, setShowChatPanel] = useState(false);

  const [showRagPanel, setShowRagPanel] = useState(false);

  const skill = useSelector((state) => state.skillReducer.trainDraft);
  const loading = useSelector((state) => state.skillReducer.loading);
  const [rootNodes, setRootNodes] = useState({});
  const userRole = useSelector(
    (state) => state.organizationReducer?.currentOrgUser
  );
  const userSub = useSelector((state) => state.userReducer?.user?.sub);
  const userEmail = useSelector((state) => state.userReducer?.user?.email);
  const readOnly = useSelector((state) => state.skillReducer?.readOnly);

  const advancedConfigPanel = useSelector(
    (state) => state.skillReducer.advancedConfigPanel
  );

  const varPanel = useSelector((state) => state.skillReducer.variablePanel);
  const chatGptConfig = useSelector((state) => state.skillReducer.chatPanel);
  const ragConfig = useSelector((state) => state.skillReducer.ragPanel);
  useEffect(() => {
    let _actions = _.cloneDeep(skill?.RAW_DATA?.actions);
    let actions = getRearrangedData(_actions || []);
    let vars = getFlowVars(_actions || []);
    getGlobalVars(_actions || []);
    let _rootNodes = getRootNodes(_actions || []);
    setNodes(actions);
    if (vars?.length !== flowVars?.length) {
      setFlowVars(vars);
    }
    // if (_rootNodes && _rootNodes.length !== rootNodes.length) {
    setRootNodes(_rootNodes);
    // }
    setValidNodes(getValidNodes(skill?.TEMPLATE));
    setDatasetVars(getDatasetVars(_actions || []));
  }, [skill]);

  useEffect(() => {
    let visible = advancedConfigPanel?.record?.panelVisible;
    setShowConfigPanel(visible);
  }, [advancedConfigPanel]);

  useEffect(() => {
    setLoader(loading);
  }, [loading]);

  useEffect(() => {
    setShowVariablesPanel(varPanel);
  }, [varPanel]);

  useEffect(() => {
    let visible = chatGptConfig?.panelVisible;

    setShowChatPanel(visible);
  }, [chatGptConfig]);
  useEffect(() => {
    let visible = ragConfig?.panelVisible;

    setShowRagPanel(visible);
  }, [ragConfig]);
  const getValidNodes = (template) => {
    // if (template === "WebAutomation") {
    //   setCustomClassName("");
    //   return registerNodes.filter(
    //     (i) => !["loop", "loop-nodes"].includes(i.type)
    //   );
    // }
    if (template === "UserDocumentation" || template === "In-App Walkthrough") {
      setCustomClassName("");
      return registerNodes.filter((i) =>
        ["start", "end", "record", "addSkillSet"].includes(i.type)
      );
    }
    if (template === "UserOnboarding") {
      setCustomClassName("");
      return registerNodes.filter((i) =>
        [
          "start",
          "end",
          "toDoSkill",
          "try-catch-node",
          "try",
          "record",
        ].includes(i.type)
      );
    }
    if (template === "Skill Set") {
      setCustomClassName("");
      return registerNodes.filter((i) =>
        [
          "start",
          "end",
          "addSkillSet",
          "try-catch-node",
          "try",
          "record",
        ].includes(i.type)
      );
    } else {
      setCustomClassName("flow-builder-for-loop");
      return registerNodes;
      // return registerNodes.filter((i) => !["GET_AZURESECRET"].includes(i.type));
    }
  };

  const handleChange = (_nodes, e) => {
    let diff = {};
    switch (e) {
      case "init-builder":
        setNodes(_nodes);
        break;
      case "click-node":
      case "close-drawer":
        break;
      case "add-node__record":
      case "node__record":
        _nodes = _nodes.filter((i) => !(i.isStart || i.isEnd));
        dispatch(
          setDraft({
            ...skill,
            RAW_DATA: { ...skill.RAW_DATA, actions: _nodes },
          })
        );
        saveFlow(skill, _nodes);
        break;
      case "add-node__branch":
        _nodes = _nodes.filter((i) => !(i.isStart || i.isEnd));
        _nodes.forEach((i) => {
          if (i.type === "branch") {
            i.nodeId = i.id;
            i.kind = "branch";
          }
        });
        dispatch(
          setDraft({
            ...skill,
            RAW_DATA: { ...skill.RAW_DATA, actions: _nodes },
          })
        );
        saveFlow(skill, _nodes);

        break;
      case "add-node__wait":
        _nodes = _nodes.filter((i) => !(i.isStart || i.isEnd));
        diff = findDiff(skill?.RAW_DATA?.actions, _nodes, "wait");
        _nodes = findAndUpdate(_nodes, diff.id, { ...getWaitNode("1") });
        dispatch(
          setDraft({
            ...skill,
            RAW_DATA: { ...skill.RAW_DATA, actions: _nodes },
          })
        );
        break;

      case "add-node__loop":
        _nodes = _nodes.filter((i) => !(i.isStart || i.isEnd));
        diff = findDiff(skill?.RAW_DATA?.actions, _nodes, "loop");
        diff.actionType = "loop";
        diff.children.pop();
        diff.children[0].actionType = "loop-nodes";
        setCustomClassName("flow-builder-for-loop");
        _nodes = findAndUpdate(_nodes, diff.id, { ...diff });
        dispatch(
          setDraft({
            ...skill,
            RAW_DATA: { ...skill.RAW_DATA, actions: _nodes },
          })
        );
        break;

      case "add-node__try":
        _nodes = _nodes.filter((i) => !(i.isStart || i.isEnd));
        diff = findDiff(skill?.RAW_DATA?.actions, _nodes, "try");
        diff.actionType = "try";
        diff.children[0].name = "Action Flow";
        diff.children[1].name = "Error Handle";
        _nodes = findAndUpdate(_nodes, diff.id, { ...diff });
        dispatch(
          setDraft({
            ...skill,
            RAW_DATA: { ...skill.RAW_DATA, actions: _nodes },
          })
        );
        break;

      case "add-node__try-catch-node":
        _nodes = _nodes.filter((i) => !(i.isStart || i.isEnd));
        diff = findDiff(skill?.RAW_DATA?.actions, _nodes, "try-catch-node");
        _nodes = findAndRemove(_nodes, diff.id);
        dispatch(
          setDraft({
            ...skill,
            RAW_DATA: { ...skill.RAW_DATA, actions: _nodes },
          })
        );
        break;

      case "add-node__review":
        _nodes = _nodes.filter((i) => !(i.isStart || i.isEnd));
        diff = findDiff(skill?.RAW_DATA?.actions, _nodes, "review");
        diff.actionType = "review";
        diff.children[0].name = "Approve";
        diff.children[1].name = "Reject";
        _nodes = findAndUpdate(_nodes, diff.id, { ...diff });
        _nodes = findAndAdd(_nodes, diff.id, { ...getCallbackNode(diff.id) });

        dispatch(
          setDraft({
            ...skill,
            RAW_DATA: { ...skill.RAW_DATA, actions: _nodes },
          })
        );
        break;

      case "add-node__review-node":
        _nodes = _nodes.filter((i) => !(i.isStart || i.isEnd));
        diff = findDiff(skill?.RAW_DATA?.actions, _nodes, "review-node");
        _nodes = findAndRemove(_nodes, diff.id);
        dispatch(
          setDraft({
            ...skill,
            RAW_DATA: { ...skill.RAW_DATA, actions: _nodes },
          })
        );
        break;

      case "add-node__loop-nodes":
        _nodes = _nodes.filter((i) => !(i.isStart || i.isEnd));
        diff = findDiff(skill?.RAW_DATA?.actions, _nodes, "loop-nodes");
        _nodes = findAndRemove(_nodes, diff.id);
        dispatch(
          setDraft({
            ...skill,
            RAW_DATA: { ...skill.RAW_DATA, actions: _nodes },
          })
        );
        break;

      case "add-node__continue":
        _nodes = _nodes.filter((i) => !(i.isStart || i.isEnd));
        diff = findDiff(skill?.RAW_DATA?.actions, _nodes, "continue");
        _nodes = findAndUpdate(_nodes, diff.id, { ...getContinueNode() });
        dispatch(
          setDraft({
            ...skill,
            RAW_DATA: { ...skill.RAW_DATA, actions: _nodes },
          })
        );
        break;
      case "add-node__break":
        _nodes = _nodes.filter((i) => !(i.isStart || i.isEnd));
        diff = findDiff(skill?.RAW_DATA?.actions, _nodes, "break");
        _nodes = findAndUpdate(_nodes, diff.id, { ...getBreakNode() });
        dispatch(
          setDraft({
            ...skill,
            RAW_DATA: { ...skill.RAW_DATA, actions: _nodes },
          })
        );
        break;
      case "add-node__closetab":
        _nodes = _nodes.filter((i) => !(i.isStart || i.isEnd));
        diff = findDiff(skill?.RAW_DATA?.actions, _nodes, "closetab");
        _nodes = findAndUpdate(_nodes, diff.id, { ...getCloseTabNode() });
        dispatch(
          setDraft({
            ...skill,
            RAW_DATA: { ...skill.RAW_DATA, actions: _nodes },
          })
        );
        break;

      case "add-node__read":
        _nodes = _nodes.filter((i) => !(i.isStart || i.isEnd));
        diff = findDiff(skill?.RAW_DATA?.actions, _nodes, "read");
        _nodes = findAndUpdate(_nodes, diff.id, { ...getReadNode() });
        dispatch(
          setDraft({
            ...skill,
            RAW_DATA: { ...skill.RAW_DATA, actions: _nodes },
          })
        );
        break;

      case "add-node__filesandfolders":
        _nodes = _nodes.filter((i) => !(i.isStart || i.isEnd));
        diff = findDiff(skill?.RAW_DATA?.actions, _nodes, "filesandfolders");
        _nodes = findAndUpdate(_nodes, diff.id, { ...getFilesAndFolderNode() });

        dispatch(
          setDraft({
            ...skill,
            RAW_DATA: { ...skill.RAW_DATA, actions: _nodes },
          })
        );
        break;

      case "add-node__excel":
        _nodes = _nodes.filter((i) => !(i.isStart || i.isEnd));
        diff = findDiff(skill?.RAW_DATA?.actions, _nodes, "excel");
        _nodes = findAndUpdate(_nodes, diff.id, { ...getExcelActionNode() });

        dispatch(
          setDraft({
            ...skill,
            RAW_DATA: { ...skill.RAW_DATA, actions: _nodes },
          })
        );
        break;
      case "add-node__httpapi":
        _nodes = _nodes.filter((i) => !(i.isStart || i.isEnd));
        diff = findDiff(skill?.RAW_DATA?.actions, _nodes, "httpapi");
        _nodes = findAndUpdate(_nodes, diff.id, { ...getHttpApiNode() });

        dispatch(
          setDraft({
            ...skill,
            RAW_DATA: { ...skill.RAW_DATA, actions: _nodes },
          })
        );
        break;

      case "add-node__supervityOcr":
        _nodes = _nodes.filter((i) => !(i.isStart || i.isEnd));
        diff = findDiff(skill?.RAW_DATA?.actions, _nodes, "supervityOcr");
        _nodes = findAndUpdate(_nodes, diff.id, { ...getSupervityOCRNode() });

        dispatch(
          setDraft({
            ...skill,
            RAW_DATA: { ...skill.RAW_DATA, actions: _nodes },
          })
        );
        break;

      case "add-node__assign":
        _nodes = _nodes.filter((i) => !(i.isStart || i.isEnd));
        diff = findDiff(skill?.RAW_DATA?.actions, _nodes, "assign");
        _nodes = findAndUpdate(_nodes, diff.id, { ...getAssignNode() });

        dispatch(
          setDraft({
            ...skill,
            RAW_DATA: { ...skill.RAW_DATA, actions: _nodes },
          })
        );
        break;
      case "add-node__sendMail":
        _nodes = _nodes.filter((i) => !(i.isStart || i.isEnd));
        diff = findDiff(skill?.RAW_DATA?.actions, _nodes, "sendMail");
        _nodes = findAndUpdate(_nodes, diff.id, { ...getSendMailNode() });

        dispatch(
          setDraft({
            ...skill,
            RAW_DATA: { ...skill.RAW_DATA, actions: _nodes },
          })
        );
        break;

      case "add-node__invokeSkill":
        _nodes = _nodes.filter((i) => !(i.isStart || i.isEnd));
        diff = findDiff(skill?.RAW_DATA?.actions, _nodes, "invokeSkill");
        _nodes = findAndUpdate(_nodes, diff.id, { ...getInvokeSkillNode() });

        dispatch(
          setDraft({
            ...skill,
            RAW_DATA: { ...skill.RAW_DATA, actions: _nodes },
          })
        );
        break;
      case "add-node__toDoSkill":
        _nodes = _nodes.filter((i) => !(i.isStart || i.isEnd));
        diff = findDiff(skill?.RAW_DATA?.actions, _nodes, "toDoSkill");
        _nodes = findAndUpdate(_nodes, diff.id, { ...getToDoSkillNode() });
        dispatch(
          setDraft({
            ...skill,
            RAW_DATA: { ...skill.RAW_DATA, actions: _nodes },
          })
        );
        break;
      case "add-node__addSkillSet":
        _nodes = _nodes.filter((i) => !(i.isStart || i.isEnd));
        diff = findDiff(skill?.RAW_DATA?.actions, _nodes, "addSkillSet");
        _nodes = findAndUpdate(_nodes, diff.id, { ...getAddSkillNode() });
        dispatch(
          setDraft({
            ...skill,
            RAW_DATA: { ...skill.RAW_DATA, actions: _nodes },
          })
        );
        break;
      case "add-node__S3_FILE_DOWNLOAD":
        _nodes = _nodes.filter((i) => !(i.isStart || i.isEnd));
        diff = findDiff(skill?.RAW_DATA?.actions, _nodes, "S3_FILE_DOWNLOAD");
        _nodes = findAndUpdate(_nodes, diff.id, { ...downloadS3Node() });
        dispatch(
          setDraft({
            ...skill,
            RAW_DATA: { ...skill.RAW_DATA, actions: _nodes },
          })
        );
        break;
      case "add-node__S3_CONNECT":
        _nodes = _nodes.filter((i) => !(i.isStart || i.isEnd));
        diff = findDiff(skill?.RAW_DATA?.actions, _nodes, "S3_CONNECT");
        _nodes = findAndUpdate(_nodes, diff.id, { ...connectS3Node() });
        dispatch(
          setDraft({
            ...skill,
            RAW_DATA: { ...skill.RAW_DATA, actions: _nodes },
          })
        );
        break;
      case "add-node__SMTP":
        _nodes = _nodes.filter((i) => !(i.isStart || i.isEnd));
        diff = findDiff(skill?.RAW_DATA?.actions, _nodes, "SMTP");
        _nodes = findAndUpdate(_nodes, diff.id, { ...getSMTPNode() });
        dispatch(
          setDraft({
            ...skill,
            RAW_DATA: { ...skill.RAW_DATA, actions: _nodes },
          })
        );
        break;
      case "add-node__S3_FILE_ARCHIVE":
        _nodes = _nodes.filter((i) => !(i.isStart || i.isEnd));
        diff = findDiff(skill?.RAW_DATA?.actions, _nodes, "S3_FILE_ARCHIVE");
        _nodes = findAndUpdate(_nodes, diff.id, { ...connectS3ArchiveNode() });
        dispatch(
          setDraft({
            ...skill,
            RAW_DATA: { ...skill.RAW_DATA, actions: _nodes },
          })
        );
        break;

      case "add-node__READ_CREDENTIALS":
        _nodes = _nodes.filter((i) => !(i.isStart || i.isEnd));
        diff = findDiff(skill?.RAW_DATA?.actions, _nodes, "READ_CREDENTIALS");
        _nodes = findAndUpdate(_nodes, diff.id, { ...readCredentialsNode() });
        dispatch(
          setDraft({
            ...skill,
            RAW_DATA: { ...skill.RAW_DATA, actions: _nodes },
          })
        );
        break;
      case "add-node__READ_TABLE":
        _nodes = _nodes.filter((i) => !(i.isStart || i.isEnd));
        diff = findDiff(skill?.RAW_DATA?.actions, _nodes, "READ_TABLE");
        _nodes = findAndUpdate(_nodes, diff.id, { ...readTableNode() });
        dispatch(
          setDraft({
            ...skill,
            RAW_DATA: { ...skill.RAW_DATA, actions: _nodes },
          })
        );
        break;
      case "add-node__CLOSE":
        _nodes = _nodes.filter((i) => !(i.isStart || i.isEnd));
        diff = findDiff(skill?.RAW_DATA?.actions, _nodes, "CLOSE");
        _nodes = findAndUpdate(_nodes, diff.id, { ...closeFileNode() });
        dispatch(
          setDraft({
            ...skill,
            RAW_DATA: { ...skill.RAW_DATA, actions: _nodes },
          })
        );
        break;
      case "add-node__KEY_STROKES":
        _nodes = _nodes.filter((i) => !(i.isStart || i.isEnd));
        diff = findDiff(skill?.RAW_DATA?.actions, _nodes, "KEY_STROKES");
        _nodes = findAndUpdate(_nodes, diff.id, { ...keyboardShortcutNode() });
        dispatch(
          setDraft({
            ...skill,
            RAW_DATA: { ...skill.RAW_DATA, actions: _nodes },
          })
        );
        break;
      case "add-node__CSV_HEADER":
        _nodes = _nodes.filter((i) => !(i.isStart || i.isEnd));
        diff = findDiff(skill?.RAW_DATA?.actions, _nodes, "CSV_HEADER");
        _nodes = findAndUpdate(_nodes, diff.id, { ...csvHeaderNode() });
        dispatch(
          setDraft({
            ...skill,
            RAW_DATA: { ...skill.RAW_DATA, actions: _nodes },
          })
        );
        break;
      case "add-node__GET_CLIPBOARD":
        _nodes = _nodes.filter((i) => !(i.isStart || i.isEnd));
        diff = findDiff(skill?.RAW_DATA?.actions, _nodes, "GET_CLIPBOARD");
        _nodes = findAndUpdate(_nodes, diff.id, { ...clipboardNode() });
        dispatch(
          setDraft({
            ...skill,
            RAW_DATA: { ...skill.RAW_DATA, actions: _nodes },
          })
        );
        break;
      case "add-node__SCREENSHOT":
        _nodes = _nodes.filter((i) => !(i.isStart || i.isEnd));
        diff = findDiff(skill?.RAW_DATA?.actions, _nodes, "SCREENSHOT");
        _nodes = findAndUpdate(_nodes, diff.id, { ...getScreenshotNode() });
        dispatch(
          setDraft({
            ...skill,
            RAW_DATA: { ...skill.RAW_DATA, actions: _nodes },
          })
        );
        break;
      case "add-node__hover":
        _nodes = _nodes.filter((i) => !(i.isStart || i.isEnd));
        diff = findDiff(skill?.RAW_DATA?.actions, _nodes, "hover");
        _nodes = findAndUpdate(_nodes, diff.id, { ...getHoverNode() });
        dispatch(
          setDraft({
            ...skill,
            RAW_DATA: { ...skill.RAW_DATA, actions: _nodes },
          })
        );
        break;
      case "add-node__dbConnection":
        _nodes = _nodes.filter((i) => !(i.isStart || i.isEnd));
        diff = findDiff(skill?.RAW_DATA?.actions, _nodes, "dbConnection");
        _nodes = findAndUpdate(_nodes, diff.id, { ...getDBNode() });
        dispatch(
          setDraft({
            ...skill,
            RAW_DATA: { ...skill.RAW_DATA, actions: _nodes },
          })
        );
        break;
      case "add-node__XML_TO_JSON":
        _nodes = _nodes.filter((i) => !(i.isStart || i.isEnd));
        diff = findDiff(skill?.RAW_DATA?.actions, _nodes, "XML_TO_JSON");
        _nodes = findAndUpdate(_nodes, diff.id, { ...getXmlToJsonNode() });
        dispatch(
          setDraft({
            ...skill,
            RAW_DATA: { ...skill.RAW_DATA, actions: _nodes },
          })
        );
        break;
      case "add-node__CHAT_GPT":
        _nodes = _nodes.filter((i) => !(i.isStart || i.isEnd));
        diff = findDiff(skill?.RAW_DATA?.actions, _nodes, "CHAT_GPT");
        _nodes = findAndUpdate(_nodes, diff.id, { ...getGptNode() });
        dispatch(
          setDraft({
            ...skill,
            RAW_DATA: { ...skill.RAW_DATA, actions: _nodes },
          })
        );
        saveFlow(skill, _nodes);
        break;
      case "add-node__RAG":
        _nodes = _nodes.filter((i) => !(i.isStart || i.isEnd));
        diff = findDiff(skill?.RAW_DATA?.actions, _nodes, "RAG");
        _nodes = findAndUpdate(_nodes, diff.id, { ...getRagNode() });
        dispatch(
          setDraft({
            ...skill,
            RAW_DATA: { ...skill.RAW_DATA, actions: _nodes },
          })
        );
        saveFlow(skill, _nodes);
        break;

      case "add-node__THROW":
        _nodes = _nodes.filter((i) => !(i.isStart || i.isEnd));
        diff = findDiff(skill?.RAW_DATA?.actions, _nodes, "THROW");
        _nodes = findAndUpdate(_nodes, diff.id, { ...getThrowNode() });
        dispatch(
          setDraft({
            ...skill,
            RAW_DATA: { ...skill.RAW_DATA, actions: _nodes },
          })
        );
        break;
      default:
        _nodes = _nodes.filter((i) => !(i.isStart || i.isEnd));
        dispatch(
          setDraft({
            ...skill,
            RAW_DATA: { ...skill.RAW_DATA, actions: _nodes },
          })
        );
    }
  };

  const closeDrawer = () => {
    dispatch(closeAdvancedConfigPanel());
    setShowConfigPanel(false);
  };

  const closeVariablePanel = () => {
    setShowVariablesPanel(false);
    dispatch(setVariablePanel(false));
  };

  const closeChatPanel = () => {
    setShowChatPanel(false);
    dispatch(setChatPanel({ data: null, panelVisible: false }));
  };
  const closeRagPanel = () => {
    setShowRagPanel(false);
    dispatch(setRagPanel({ data: null, panelVisible: false }));
  };

  useEffect(() => {
    const handleAIMessage = (evt) => {
      const msg = evt.detail;
      const workflow = msg?.workflow;
      const topLevelActionsLength =
        skill.RAW_DATA.actions[0].children[0].children.length;
      const rawData = cloneDeep(skill.RAW_DATA);
      const actions = workflow.steps.map((step, idx) => {
        return {
          ...step,
          ...(step?.actionConfig || {}),
          description: step.title,
          id: `${step.key}-${uuid()}`,
          type: step.type || step.groupType || step.key || step.actionType,
          key: step.key,
          actionType: step.action_type,
          path: ["1", "children", "0", "children", topLevelActionsLength + idx],
        };
      });
      rawData.actions[0].children[0].children.push(...actions);
      dispatch(
        setDraft({
          ...skill,
          RAW_DATA: rawData,
        })
      );
    };
    document.addEventListener("scw-new-ai-msg", handleAIMessage);
    return () => {
      document.removeEventListener("scw-new-ai-msg", handleAIMessage);
    };
  }, [dispatch, skill]);

  return (
    <>
      {skill?.TEMPLATE === "UserDocumentation" || readOnly == true ? null : (
        <>
          {/* <Drawer
            title="Variants"
            placement="bottom"
            width={400}
            visible={false}
          >
            <Variants />
          </Drawer> */}
          <Drawer
            title="Configuration"
            placement="right"
            width={300}
            onClose={() => closeDrawer()}
            visible={showConfigPanel}
          >
            {showConfigPanel ? (
              <AdvancedSettingsPanel
                data={advancedConfigPanel}
                updateConfig={saveAdvancedConfig}
              />
            ) : null}
          </Drawer>
          <Drawer
            title="Settings"
            placement="right"
            width={900}
            onClose={() => closeVariablePanel()}
            visible={showVariablesPanel}
          >
            {showVariablesPanel ? (
              <VariablesPanel variables={skill?.RAW_DATA?.variables} />
            ) : null}
          </Drawer>

          <Drawer
            title="Generative AI Configuration"
            placement="right"
            width={1065}
            visible={showChatPanel}
            onClose={() => closeChatPanel()}
          >
            {showChatPanel ? (
              <ChatGptConfig
                data={chatGptConfig?.record}
                updateConfig={saveChatConfig}
                closeDrawer={closeChatPanel}
              />
            ) : null}
          </Drawer>

          <Drawer
            title="RAG Config"
            placement="right"
            width={1065}
            visible={showRagPanel}
            onClose={() => closeRagPanel()}
          >
            {showRagPanel ? (
              <RagConfig
                data={ragConfig?.record}
                updateConfig={saveChatConfig}
                closeDrawer={closeRagPanel}
              />
            ) : null}
          </Drawer>
        </>
      )}

      {/* <div className="fixed-bottom-icon">
        <div className="fxd-icon">
          <Tooltip title="Settings">
            <img src={settingIconFx} />
          </Tooltip>
        </div>
        <div className="fxd-icon">
          <Tooltip title="Audit Trail">
            <img src={logsIconFx} />
          </Tooltip>
        </div>
        <div className="fxd-icon">
          <Tooltip title="Getting Started">
            <img src={startIconFx} />
          </Tooltip>
        </div>        
      </div> */}

      {/* <div className="fixed-icons-bottom">
        <TemplateInstructions state={skill?.TEMPLATE} />

        <button
          className="fxd-icon settings-icon"
          onClick={() => {
            dispatch(setVariablePanel(true));
            setShowVariablesPanel(true);
          }}
        >
          <Tooltip title="Settings">
            <img src={settingIconFx} />
          </Tooltip>
        </button>

        <button
          style={{
            backgroundColor: "#fff",
            padding: "10px 20px",
            position: "absolute",
            borderRadius: 2,
            left: "2%",
            top: "50px",
            zIndex: 1,
          }}
          onClick={() => {
            let _path = window.location.pathname.replace(
              "viewSkill",
              "approvals"
            );
            history.push(_path);
          }}
        >
          Approvals
        </button>
      </div> */}

      {loading ? (
        <Loader
          styles={{ width: "80px", margin: "auto" }}
          root={{ display: "flex" }}
        />
      ) : (
        <FlowBuilder
          className={`outer-drag scrollable ${customClassName}`}
          nodes={nodes}
          onChange={handleChange}
          registerNodes={validNodes}
          zoomTool
          skillTemplate={skill?.TEMPLATE}
          skillType={skill?.TYPE}
          flowVariables={flowVars}
          datasetVariables={datasetVars}
          // readonly={parseInt(skill?.organizationId) !== currentTeam?.id}
          readonly={readOnly}
          backgroundColor={"#F2F5F6"}
          rootNodes={rootNodes}
        />
      )}
      {skill?.TEMPLATE === "Process Discovery" ? null : (
        <button
          className="fxd-icon settings-icon"
          onClick={() => {
            dispatch(setVariablePanel(true));
            setShowVariablesPanel(true);
          }}
        >
          <Tooltip title="Settings">
            <img src={settingIconFx} />
          </Tooltip>
        </button>
      )}
    </>
  );
};

export default connect(null, {})(NodeForm);
